PJQ.collections.primeContracts = {};

PJQ.models.primeContracts = {};

PJQ.views.primeContracts = {};

PJQ.modules.primeContracts = {
    routes: [
        {
            route: 'projects/:projectId/contracts',
            name: 'primecontracts',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "primecontracts");
            }
        },
        {
            route: 'projects/:projectId/contracts/:primeContractId',
            name: 'primecontract',
            callback: function (projectId, primeContractId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "primecontracts", {
                    primeContractId: parseInt(primeContractId)
                });
            }
        },
        {
            route: 'projects/:projectId/contracts/changeorders',
            name: 'primecontractchangeorders',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "primecontracts", {
                    view: 'changeorders'
                });
            }
        },
        {
            route: 'projects/:projectId/contracts/changeorders/:changeOrderId',
            name: 'primecontractchangeorder',
            callback: function (projectId, changeOrderId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "primecontracts", {
                    changeOrderId: parseInt(changeOrderId)
                });
            }
        },
        {
            route: 'projects/:projectId/contracts/changerequests',
            name: 'primecontractchangerequests',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "primecontracts", {
                    view: 'changerequests'
                });
            }
        },
        {
            route: 'projects/:projectId/changerequests/:changeRequestId',
            name: 'primecontractchangerequest',
            callback: function (projectId, changeRequestId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "primecontracts", {
                    changeRequestId: parseInt(changeRequestId)
                });
            }
        },
        {
            route: 'projects/:projectId/contractchangeorders',
            name: 'primecontractchangeorders',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "primecontracts", {
                    view: 'changeorders'
                });
            }
        },
        {
            route: 'projects/:projectId/contractchangeorders/:changeOrderId',
            name: 'projectprimecontractchangeorder',
            callback: function (projectId, changeOrderId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "primecontracts", {
                    changeOrderId: parseInt(changeOrderId)
                });
            }
        },
        {
            route: 'projects/:projectId/contracts/invoices',
            name: 'receivableinvoices',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "primecontracts", {
                    view: 'invoices'
                });
            }
        },
        {
            route: 'projects/:projectId/receivableinvoices',
            name: 'receivableinvoices',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "primecontracts", {
                    view: 'invoices'
                });
            }
        },
        {
            route: 'projects/:projectId/receivableinvoices/:invoiceId',
            name: 'receivableinvoice',
            callback: function (projectId, invoiceId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "primecontracts", {
                    invoiceId: parseInt(invoiceId)
                });
            }
        }
    ]
};

PJQ.app.addRoutes(PJQ.modules.primeContracts.routes);

PJQ.views.primeContracts.ChangeOrderDataTable = PJQ.views.dataTables.DataTable.extend({
    defaults: {
        language: {
            emptyTable: 'No Change Orders have been created yet',
            zeroRecords: "No Change Orders matched the search criteria"
        },
        subTemplates: {
            header: new PJQ.templating.Template(PJQ.constants.modules.PRIMECONTRACTS, 'data-table-header-change-orders')
        },
        toggleRowClass: '.change-order-toggle-row'
    },
    events: {
        'click .view-contract': 'viewPrimeContractClicked'
    },
    beforeDataTableRender: function () {
        this.options.pageLength = this.options.settings ? this.options.settings.rowsPerPage : 10;
    },
    getDefaultFilter: function () {
        return _.size(this.options.statusIds) > 0 ? this.options.statusIds : this.options.userSettings.get('defaultStatusFilter');
    },
    afterHeaderRender: function () {
        new PJQ.inputs.Selectpicker({
            el: this.$('.change-orders-status-filter'),
            defaultValue: this.getDefaultFilter(),
            isIntChoices: true,
            isMultiple: true,
            noneSelectedText: 'No Filters',
            onChange: _.bind(function (value) {
                this.setFilter(PJQ.constants.primeContracts.changeOrderFilterType.STATUS_FILTER, value);
            }, this)
        });
        this.setFilter(PJQ.constants.primeContracts.changeOrderFilterType.STATUS_FILTER, this.getDefaultFilter());
    },
    getFilterData: function () {
        let statusFilter = this.getFilter(PJQ.constants.primeContracts.changeOrderFilterType.STATUS_FILTER);
        if (_.size(statusFilter) === 0) {
            return this.options.data;
        }

        return _.filter(this.options.data, function (row) {
            return (_.size(statusFilter) === 0 || _.contains(statusFilter, row.get('statusId')));
        });
    },
    getColumns: function (includeAllColumns = false) {
        this.options.canViewPrimeContracts = PJQ.app.session.project.hasPermission('primeContracts.canView');

        let columns = [],
            includeColumns = ['status', 'contract', 'number', 'changeReason', 'description', 'invoicedDate', 'dueDate', 'createdOn', 'amount', 'taxAmount', 'grandTotal'];

        if (this.options.customFields) {
            _.each(this.options.customFields.models, _.bind(function (customField) {
                includeColumns.push('fieldValue' + customField.get('fieldNumber'));
            }, this));
        }

        if (!includeAllColumns) {
            if (this.options.settings && _.size(this.options.settings.columns) > 0)
                includeColumns = this.options.settings.columns;
            else
                includeColumns = this.options.settings && this.options.settings.columnsDefault ? this.options.settings.columnsDefault : includeColumns;

            columns.push({
                "columnData": "childData",
                "data": null,
                "title": "",
                "width": "20px",
                "orderable": false,
                "searchable": false,
                "defaultContent": '',
                "render": (data, type, row) => {
                    if (!this.options.isAdmin) {
                        return "";
                    }

                    let exObj = row.get('externalObject');
                    if (exObj == null) {
                        return '';
                    }

                    return PJQ.helpers.erp.getERPBadge(exObj.status, exObj);
                }
            });
        }

        _.each(includeColumns, _.bind(function (columnName) {
            switch (columnName) {
                case 'status':
                    columns.push({
                        "columnData": "status",
                        "data": "attributes.statusId",
                        "title": "Status",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.constants.primeContracts.changeOrderStatusNames[row.get('statusId')]
                        }, this)
                    });
                    break;
                case 'contract':
                    columns.push({
                        "columnData": "contract",
                        "title": "Contract",
                        "data": "attributes.primeContractNumber",
                        "width": "200px",
                        "orderable": true,
                        "render": _.bind(function (data, type, row) {
                            if (type === 'sort' || type === 'type') {
                                return row.get('primeContractNumber');
                            }

                            if (this.options.canViewPrimeContracts) {
                                return '<a class="view-contract" href="javascript:void(0)" data-id="' + row.get('primeContractId') + '">' + row.get('primeContractNumber') + '</a>';
                            }
                            return data;
                        }, this)
                    },);
                    break;
                case 'number':
                    columns.push({
                        "columnData": "number",
                        "data": "attributes.number",
                        "title": "Number",
                        "width": "200px",
                        "render": _.bind(function (data, type, row) {
                            if (type === 'sort' || type === 'type') {
                                return row.get('number');
                            }
                            return '<a href="javascript:void(0)" class="btn-view-change-order">' + data + '</a>'
                        }, this)
                    });
                    break;
                case 'changeReason':
                    columns.push({
                        "columnData": "changeReason",
                        "data": "attributes.changeReason",
                        "title": "Change Reason"
                    });
                    break;
                case 'description':
                    columns.push({
                        "columnData": "description",
                        "data": "attributes.description",
                        "title": "Description"
                    });
                    break;
                case 'invoicedDate':
                    columns.push({
                        "columnData": "invoicedDate",
                        "data": "attributes.invoicedDate",
                        "title": 'Invoiced Date',
                        "width": '120px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'dueDate':
                    columns.push({
                        "columnData": "dueDate",
                        "data": "attributes.dueDate",
                        "title": 'Due Date',
                        "width": '120px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'createdOn':
                    columns.push({
                        "columnData": "createdOn",
                        "data": "attributes.createdOn",
                        "title": 'Created',
                        "width": '120px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                        }, this)
                    });
                    break;
                case 'client.companyName':
                    columns.push({
                        "columnData": "client.companyName",
                        "title": "Client",
                        "titleSettings": "Client",
                        "render": _.bind(function (data, type, row) {
                            return row.get('client') ? row.get('client').companyName : 'N/A';
                        }, this)
                    });
                    break;
                case 'amount':
                    columns.push({
                        "columnData": "amount",
                        "data": "attributes.amount",
                        "title": "Amount",
                        "width": "120px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(data);
                        }, this)
                    });
                    break;
                case 'taxAmount':
                    columns.push({
                        "columnData": "taxAmount",
                        "data": "attributes.taxAmount",
                        "title": "Tax",
                        "width": "120px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(data);
                        }, this)
                    });
                    break;
                case 'grandTotal':
                    columns.push({
                        "columnData": "grandTotal",
                        "data": "attributes.amount",
                        "title": "Grand Total",
                        "width": "120px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.getGrandTotal());
                        }, this)
                    });
                    break;
                default:
                    if (columnName.startsWith('fieldValue')) {
                        _.each(this.options.customFields.models, function (customField) {
                            if (columnName === 'fieldValue' + customField.get('fieldNumber')) {
                                columns.push({
                                    "columnData": 'fieldValue' + customField.get('fieldNumber'),
                                    "title": customField.get('name'),
                                    "render": function (data, type, row) {
                                        let fieldValue = row.getCustomFieldValue(customField.get('id'));
                                        fieldValue = (fieldValue !== null) ? fieldValue : '';
                                        switch (customField.get('fieldTypeId')) {
                                            case PJQ.constants.commitments.customFieldType.BOOLEAN:
                                                if (fieldValue != null)
                                                    fieldValue = fieldValue ? 'Yes' : 'No';
                                                break;
                                            case PJQ.constants.commitments.customFieldType.CHOICE:
                                                let choices = [];
                                                // convert single choice value into array so that the logic below can work for both types.
                                                if (typeof fieldValue === 'number')
                                                    fieldValue = [fieldValue];

                                                _.each(customField.choices.models, _.bind(function (choice) {
                                                    if (_.find(fieldValue, function (value) {
                                                        return value === choice.get('id');
                                                    }))
                                                        choices.push(choice.get('name'));
                                                }, this));

                                                fieldValue = choices.join((', '));
                                                break;
                                            case PJQ.constants.commitments.customFieldType.DATE:
                                                if (fieldValue) {
                                                    if (type !== 'sort' && type !== 'type')
                                                        fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                                                }
                                                if (fieldValue === undefined)
                                                    fieldValue = '';

                                                break;
                                            case PJQ.constants.commitments.customFieldType.DATETIME:
                                                if (fieldValue) {
                                                    if (type !== 'sort' && type !== 'type')
                                                        fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                                                }
                                                if (fieldValue === undefined)
                                                    fieldValue = '';

                                                break;
                                            case PJQ.constants.commitments.customFieldType.INTEGER:
                                                if (type !== 'sort' && type !== 'type' && fieldValue) {
                                                    fieldValue = parseInt(fieldValue).toLocaleString();
                                                }
                                                break;
                                            case PJQ.constants.commitments.customFieldType.MONEY:
                                                if (type === 'sort' || type === 'type') {
                                                    if (fieldValue && fieldValue !== '$')
                                                        fieldValue = parseFloat(PJQ.helpers.formatHelpers.numbersOnly(fieldValue, true));
                                                    else
                                                        fieldValue = 0;
                                                } else {
                                                    fieldValue = PJQ.helpers.formatHelpers.formatCurrency(parseInt(PJQ.helpers.formatHelpers.numbersOnly(fieldValue)));
                                                }
                                                break;
                                            case PJQ.constants.commitments.customFieldType.PERCENT:
                                                if (type === 'sort' || type === 'type') {
                                                    if (fieldValue && fieldValue !== '$')
                                                        fieldValue = parseFloat(PJQ.helpers.formatHelpers.numbersOnly(fieldValue, true)).toFixed(2);
                                                    else
                                                        fieldValue = 0;
                                                } else {
                                                    fieldValue = fieldValue ? fieldValue.toString() + '%' : '';
                                                }

                                                break;
                                        }

                                        return fieldValue;
                                    }
                                });
                            }
                        });
                    }
                    break;
            }
        }, this));

        if (!includeAllColumns) {
            columns.push({
                "title": '',
                "render": _.bind(function (data, type, row) {
                    return '<div class="show-on-row-hover"><button type="button" class="btn btn-info btn-view-change-order ml-1" title="View change orrder"><i class="fal fa-arrow-alt-from-left"></i></button></div>';
                }, this),
                "orderable": false,
                "searchable": false,
                "width": "90px",
                "className": "text-center",
                "visible": true
            });
        }

        return columns;
    },
    viewPrimeContractClicked: function (e) {
        let row = this.getRow((e.currentTarget).closest('tr'));
        this.viewPrimeContract(row.data().get('primeContractId'));
    },
    viewPrimeContract: function (primeContractId) {
        new PJQ.views.primeContracts.PrimeContractEditModal({
            model: new PJQ.models.primeContracts.PrimeContract({
                id: primeContractId
            })
        });
    }
});
PJQ.views.primeContracts.ChangeOrderEditModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PRIMECONTRACTS, 'modal-change-order-edit'),
        width: '95%',
        maxWidth: 1500,
        model: null,
        isShowCloseButton: true,
        onSave: _.noop(),
        onDelete: _.noop()
    },
    events: {
        'click .btn-view-prime-contract': 'viewPrimeContract',
        'click .btn-add-line-item': 'addLineItem',
        'click .btn-save-email': 'saveEmail',
        'click .btn-save': 'saveChangeOrder',
        'click .btn-push-erp': 'pushERP',
        'click .btn-undo-push-erp': 'undoPushERP',
        'click .btn-unlink-erp': 'unlinkERP',
        'click .btn-delete': 'deleteChangeOrder',
        'click .btn-close': 'close',
        'click .btn-export': 'exportChangeOrder',
        'click .btn-export-markup': 'exportChangeOrderWithMarkup',
        'click .btn-email': 'email',
        'click .nav-link': 'activeViewChanged',
        'click .btn-copy-markups': 'copyMarkups',
        'click .btn-view-history': 'viewHistory'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;

        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;
        this.coreFieldSettings = await this.options.project.fetchPrimeContractChangeOrderFieldSettings();
        this.settings = await this.options.project.fetchPrimeContractChangeOrderSettings();
        this.customFields = await this.options.project.fetchPrimeContractChangeOrderCustomFields();
        this.costCodes = await this.options.project.fetchCostCodes();
        this.costTypes = await this.options.project.fetchCostTypes();
        this.unitsOfMeasure = await this.options.project.fetchUnitsOfMeasure();

        if (this.model == null) {
            let customFieldValues = [];
            _.each(this.customFields.models, function (model, index) {
                let value = model.get('defaultValue') ? model.get('defaultValue') : '';
                if (model.get('fieldType') === 'CHOICE') {
                    value = parseInt(value);
                }
                customFieldValues.push({
                    fieldNumber: model.get('fieldNumber'),
                    fieldTypeId: model.get('fieldTypeId'),
                    fieldType: model.get('fieldType'),
                    isMultiple: model.get('isMultiple'),
                    value: value,
                    id: model.get('id')
                })
            }, this);

            this.model = new PJQ.models.primeContracts.ChangeOrder({
                description: '',
                primeContractId: this.options.primeContract.id,
                primeContractNumber: this.options.primeContract.get('number'),
                client: this.options.primeContract.client,
                clientId: this.options.primeContract.clientId,
                accountingMethod: this.options.primeContract.get('accountingMethod'),
                projectId: this.options.primeContract.get('projectId'),
                statusId: PJQ.constants.primeContracts.changeOrderStatus.DRAFT,
                lineItems: this.options.lineItems,
                customFieldValues: customFieldValues
            });
        }

        if (!this.model.isNew()) {
            await this.model.fetch();
        }

        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();
        if (this.erpIntegration != null && this.erpIntegration.getSetting('syncProjects')) {
            await this.options.project.fetchERPObject();
        }

        if (this.options.primeContract == null) {
            this.options.primeContract = new PJQ.models.primeContracts.PrimeContract({
                id: this.model.get('primeContractId') ?? this.options.primeContract?.id
            });
        }

        if (!this.options.primeContract.isFetched) {
            await this.options.primeContract.fetch();
        }

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.options.canEdit = this.options.project.hasPermission('primeContractChangeOrders.canEdit');
        this.options.canEditLineItems = this.options.canEdit;
        this.options.canViewPrimeContracts = this.options.project.hasPermission('primeContractChangeOrders.canView');
        this.options.isAdmin = this.options.project.hasPermission('primeContractChangeOrders.isAdmin');
        this.options.canDelete = this.options.isAdmin;
        this.options.canEditStatus = this.options.isAdmin;

        this.options.disabledStatuses = null;
        let fnGetGreaterStatuses = (statusId) => {
                return _.filter(PJQ.constants.commitments.commitmentStatus, (st) => {
                    return st < statusId;
                });
            },
            status = this.model.get('statusId');
        if (status === PJQ.constants.primeContracts.changeOrderStatus.DRAFT) {
            this.options.canEdit = true;
        } else if (status === PJQ.constants.primeContracts.changeOrderStatus.APPROVED
            || status === PJQ.constants.primeContracts.changeOrderStatus.REJECTED
            || status === PJQ.constants.primeContracts.changeOrderStatus.VOID) {
            this.options.canEditLineItems = false;
            this.options.canEdit = this.options.project.hasPermission('primeContractChangeOrders.canEdit');
            this.options.canDelete = false;
        } else {
            this.options.canEdit = this.options.project.hasPermission('primeContractChangeOrders.canEdit');
            this.options.canEditLineItems = this.options.canEdit;
            this.options.canDelete = this.options.isAdmin;
        }

        if (this.model.invoices.models.length > 0) {
            this.options.disabledStatuses = fnGetGreaterStatuses(PJQ.constants.primeContracts.changeOrderStatus.APPROVED);
            this.options.canEditLineItems = false;
        }

        if (!this.options.isAdmin && this.settings.get('isMarkupAdmin') === true) {
            this.options.canEditLineItems = false;
        }

        if (this.erpIntegration != null) {
            let syncStatus = this.model.erpSyncStatus();
            if (syncStatus === PJQ.constants.integrations.erp.syncStatuses.REVIEWING
                || syncStatus === PJQ.constants.integrations.erp.syncStatuses.APPROVED
                || syncStatus === PJQ.constants.integrations.erp.syncStatuses.SYNCED
            ) {
                this.options.disabledStatuses = fnGetGreaterStatuses(PJQ.constants.primeContracts.changeOrderStatus.APPROVED);
                this.options.canEdit = false;
                this.options.canEditLineItems = false;
                this.options.canDelete = false;
            }
        }
    },
    renderData: function () {
        return {
            model: this.model,
            customFields: this.customFields,
            erpIntegration: this.erpIntegration,
            canEditLineItems: this.options.canEditLineItems,
            canEdit: this.options.canEdit,
            canDelete: this.options.canDelete,
            isAdmin: this.options.isAdmin,
            canViewPrimeContracts: this.options.canViewPrimeContracts,
            isFetched: this.isFetched,
            activeView: this.options.activeView,
            views: this.views,
            checkFieldVisible: _.bind(this.checkFieldVisible, this),
            checkFieldRequired: _.bind(this.checkFieldRequired, this),
            unCopiedMarkupsCount: _.size(this.getUnCopiedMarkups())
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.activateView(this.options.activeView);

        this.stopListening(this.model.markupItems);
        this.listenTo(this.model.markupItems, 'update', (markup) => {
            if(markup && markup.get('delete') && (markup.lineItem || markup.get('lineItemId'))){
                let lineItem = markup.lineItem ?? this.model.lineItems.findWhere({appliedMarkupId: markup.id});

                if(lineItem){
                    if(lineItem.get('id') > 0){
                        lineItem.set('delete', true);
                    } else {
                        this.model.lineItems.remove(lineItem);
                    }
                }
            }

            this.updateCounts();
            this.lineItemsView.render();
        });

        this.stopListening(this.model);
        this.listenTo(this.model, 'change:statusId', () => {
            this.renderERP();
        });
        this.stopListening(this.model.lineItems);
        this.listenTo(this.model.lineItems, 'update', () => {
            this.renderERP();
        });
        this.renderERP();

        this.renderGeneral();
        this.renderLineItems();
        this.renderMarkups();

        this.updateCounts();
    },
    updateCounts: function () {
        this.$('.count-line-items').text(_.size(_.filter(this.model.lineItems.models, (item) => {
            return !item.get('delete');
        })));
        this.$('.count-markups').text(_.size(_.filter(this.model.markupItems.models, function (item) {
            return !item.get('delete');
        })));
    },
    views: {
        GENERAL: 'PCCO_General',
        LINEITEMS: 'PCCO_LineItems',
        CHANGEORDERS: 'PCCO_ChangeOrders',
        INVOICES: 'PCCO_Invoices',
        PAYMENTS: 'PCCO_Payments',
        MARKUPS: 'PCCO_Markups'
    },
    activeViewChanged: function (e) {
        let view = e.target.hash ? e.target.hash.replace('#', '') : null;
        this.activateView(view);
    },
    activateView: function (view) {
        if (view == null) {
            view = this.views.GENERAL;
        }

        this.$('.nav-link[href="#' + view + '"]').tab('show');
        this.options.activeView = view;

        if (view === this.views.LINEITEMS) {
            // this.lineItemsView.adjustColumns();
        }
    },
    getUnCopiedMarkups: function () {
        if (this.model == null || this.model.markupItems == null
            || this.options.primeContract == null || this.options.primeContract.markupItems == null) {
            return [];
        }

        return _.filter(this.options.primeContract.markupItems.models, (contractMarkup) => {
            return !_.some(this.model.markupItems.models, (markup) => {
                return markup.get('percent') === contractMarkup.get('percent')
                    && markup.get('name') === contractMarkup.get('name')
                    && markup.get('isVertical') === contractMarkup.get('isVertical')
                    && markup.get('isCompounding') === contractMarkup.get('isCompounding');
            });
        });
    },
    copyMarkups: function () {
        let maxSort = 1;
        if (_.size(this.model.markupItems.models) > 0) {
            maxSort = _.max(this.model.markupItems.models, (markup) => {
                return markup.get('sortOrder');
            });
        }
        _.each(this.getUnCopiedMarkups(), (markup) => {
            let copiedMarkup = new PJQ.financialMarkups.models.FinancialMarkup({
                percent: markup.get('percent'),
                name: markup.get('name'),
                isVertical: markup.get('isVertical'),
                isCompounding: markup.get('isCompounding'),
                costCodeIds: markup.get('costCodeIds'),
                costTypeIds: markup.get('costTypeIds'),
                appliedCostCodeId: markup.get('appliedCostCodeId'),
                appliedCostTypeId: markup.get('appliedCostTypeId'),
                isApplied: markup.get('isApplied'),
                sortOrder: ++maxSort,
                isDirty: true
            });

            this.model.markupItems.add(copiedMarkup);
            if(copiedMarkup.get('appliedCostCodeId') && copiedMarkup.get('appliedCostTypeId')){
                this.model.markupItems.trigger('appliedMarkupChanged', copiedMarkup);
            }
        });
        this.render();
    },
    renderMarkups: function () {
        if (!this.options.isAdmin) {
            return;
        }

        this.markupsView = new PJQ.financialMarkups.views.FinancialMarkupsList({
            el: this.$('.pcco-markups'),
            collection: this.model.markupItems,
            canEdit: this.options.canEditLineItems,
            defaultToAppliedMarkups: this.settings.get('defaultToAppliedMarkups'),
        });
    },
    renderERP: function () {
        let $erp = this.$('.erp-sync'),
            syncPrimeContracts = this.erpIntegration && (this.erpIntegration.getSetting(PJQ.constants.integrations.settings.SYNC_PRIME_CONTRACTS) || this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_CONTRACT_CO_WITHOUT_PRIME_CONTRACT)),
            syncChangeOrders = this.erpIntegration && this.erpIntegration.getSetting(PJQ.constants.integrations.settings.SYNC_PRIME_CONTRACT_CHANGE_ORDERS);
        if (!this.options.isAdmin || this.erpIntegration == null || !this.options.project.isERPSynced()
            || (syncChangeOrders !== true && (syncPrimeContracts !== true && syncChangeOrders !== false))) {
            $erp.remove();
            return;
        }

        let canPush = true,
            disablePushReason = "";
        if (_.size(this.model.lineItems) === 0
            || (this.model.get('statusId') !== PJQ.constants.primeContracts.changeOrderStatus.APPROVED)) {
            canPush = false;
            disablePushReason = "Change Order must be approved and have line items";
        }

        if (!this.options.primeContract.isERPSynced() && !this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_CONTRACT_CO_WITHOUT_PRIME_CONTRACT)) {
            canPush = false;
            disablePushReason = "The contract for this change order is not synced";
        }

        PJQ.helpers.erp.renderERPButtons(this.$('.erp-sync'), {
            status: this.model.erpSyncStatus(),
            pushSupported: this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_PRIME_CONTRACT_CHANGE_ORDERS),
            canPush: canPush,
            canPushChanges: false,
            disablePushReason: disablePushReason,
            unlinkSupported: this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.UNLINK_PRIME_CONTRACT_CHANGE_ORDERS)
        });
    },
    pushERP: function (callback) {
        if (!this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_PRIME_CONTRACT_CHANGE_ORDERS)) {
            return;
        }

        this.save((success) => {
            if (success) {
                this.erpIntegration.pushPrimeContractChangeOrder(this.model, () => {
                    PJQ.notifications.notify.successNotify({
                        message: 'Contract Change Order pushed to ERP'
                    });

                    if (typeof this.options.onSave === 'function') {
                        this.options.onSave(this.model);
                    }

                    if (callback && typeof callback === 'function') {
                        callback();
                    } else {
                        this.render();
                    }
                });
            }
        });
    },
    undoPushERP: function () {
        if (this.model.erpSyncStatus() === PJQ.constants.integrations.erp.syncStatuses.REVIEWING) {
            this.erpIntegration.undoPush(this.model, () => {
                PJQ.notifications.notify.successNotify({
                    message: 'Contract Change Order removed from ERP approval'
                });

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }

                this.render();
            });
        }
    },
    unlinkERP: function () {
        new PJQ.views.modals.YesNo({
            header: "Unlink from ERP",
            body: "Are you sure you want to unlink this Contract Change Order from your ERP system?",
            onYes: () => {
                let loader = new PJQ.Loader(this.$('.modal-content'));
                this.erpIntegration.unlinkPrimeContractChangeOrder(this.model, _.bind(function (success) {
                    if (success) {
                        loader.remove();
                        PJQ.notifications.notify.successNotify({
                            message: 'Contract Change Order unlinked from ERP'
                        });

                        if (typeof this.options.onSave === 'function') {
                            this.options.onSave(this.model);
                        }

                        this.render();
                    }
                }, this));
            }
        });
    },
    renderGeneral: function () {
        new PJQ.Binder(this.$el, this.model, {
            canEdit: !this.options.canEdit ? false : null,
            useDecimalPercentFields: true,
            watchElements: [
                'input',
                'textarea'
            ]
        });

        let choices = _.map(PJQ.constants.primeContracts.changeOrderStatus, (st) => {
            return {
                id: st,
                name: PJQ.constants.primeContracts.changeOrderStatusNames[st],
                disabled: this.options.disabledStatuses != null && this.options.disabledStatuses.indexOf(st) > -1
            }
        });
        this.statusPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-status'),
            choices: choices,
            defaultValue: this.model.get('statusId') != null ? this.model.get('statusId') : 2,
            canEdit: this.options.canEditStatus,
            isMultiple: false,
            isIntChoices: true,
            onChange: _.bind(function (newStatus) {
                let oldStatus = this.model.get('statusId');
                if (newStatus === oldStatus) {
                    return;
                }

                this.model.set('statusId', newStatus);
                if (!this.model.isNew()) {
                    this.save((success) => {
                        if (success) {
                            PJQ.notifications.notify.successNotify({
                                message: 'Contract Change Order saved successfully'
                            });
                        } else {
                            this.model.set('statusId', oldStatus);
                            this.statusPicker.setValue(oldStatus);
                        }
                    });
                } else {
                    this.render();
                }
            }, this)
        });

        new PJQ.inputs.Datepicker({
            el: this.$('.change-order-due-date'),
            canEdit: this.options.canEdit,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('dueDate')
            },
            onChange: _.bind(function (newDate) {
                this.model.set('dueDate', newDate);
            }, this)
        });

        new PJQ.inputs.Datepicker({
            el: this.$('.change-order-invoiced-date'),
            canEdit: this.options.canEdit,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('invoicedDate')
            },
            onChange: _.bind(function (newDate) {
                this.model.set('invoicedDate', newDate);
            }, this)
        });

        this.clientPicker = new PJQ.views.contacts.ContactsSelectInput({
            el: this.$('.contract-client'),
            context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
            selectedContact: this.model.client,
            isSingleChoice: true,
            canViewContacts: this.options.project.hasPermission('projectContacts.canView'),
            canEdit: false,
            onChange: _.bind(function (selectedContact) {
                this.model.client = selectedContact;
                this.model.set('clientId', selectedContact ? selectedContact.id : 0);
            }, this)
        });

        this.reviewerPicker = new PJQ.views.contacts.ContactsSelectInput({
            el: this.$('.change-order-reviewer'),
            selectedContact: this.model.reviewer,
            canViewContacts: this.options.project.hasPermission('projectContacts.canView'),
            shouldHideContacts: true,
            canEdit: this.options.canEdit,
            displayContactsBlock: true,
            context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
            isSingleChoice: true,
            onChange: _.bind(function (selectedContact) {
                this.model.reviewer = selectedContact;
                this.model.set('reviewerId', selectedContact ? selectedContact.id : null);
            }, this)
        });

        this.receivedFromPicker = new PJQ.views.contacts.ContactsSelectInput({
            el: this.$('.change-order-received-from'),
            selectedContact: this.model.receivedFrom,
            canViewContacts: this.options.project.hasPermission('projectContacts.canView'),
            canEdit: this.options.canEdit,
            displayContactsBlock: true,
            context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
            isSingleChoice: true,
            onChange: _.bind(function (selectedContact) {
                this.model.receivedFrom = selectedContact;
                this.model.set('receivedFromId', selectedContact ? selectedContact.id : null);
            }, this)
        });

        if (_.size(this.customFields) > 0) {
            this.customFieldsForm = new PJQ.views.customFields.CustomFieldsForm({
                el: this.$('.change-order-custom-fields'),
                isEdit: this.options.canEdit,
                isAdmin: this.options.isAdmin,
                collection: this.customFields,
                fieldValues: this.model.get('customFieldValues'),
                onChange: _.bind(function () {
                    this.model.isDirty = true;
                }, this)
            });
        }

        if (this.checkFieldVisible('attachments')) {
            this.fileUploader = new PJQ.views.files.FileUploaderGrid({
                el: this.$('.cco-file-uploader'),
                collection: this.model.attachments,
                canUpload: this.options.canEdit,
                useApiV2: true,
                canView: false,
                canDelete: this.options.isAdmin,
                previewImageDimension: 150,
                onSuccess: _.bind(function (file) {
                    this.model.isDirty = true;
                }, this),
                onDelete: _.bind(function (attachment, callback) {
                    if (attachment.get('id') > 0) {
                        attachment.set('delete', true);
                    } else {
                        attachment.destroy();
                    }

                    this.model.isDirty = true;
                    callback();
                }, this)
            });
        }
    },
    renderLineItems() {
        if(this.lineItemsView){
            this.lineItemsView.remove();
        }

        this.lineItemsView = new PJQ.views.budget.LineItemsView({
            el: this.$('.cco-line-items'),
            collection: this.model.lineItems,
            lineItemModel: PJQ.models.primeContracts.ChangeOrderLineItem,
            accountingMethod: this.model.get('accountingMethod'),
            canEdit: this.options.canEditLineItems,
            canDelete: this.options.canEditLineItems,
            primeContractId: this.model.get('primeContractId'),
            financialMarkups: this.model.markupItems,
            showMarkup: this.options.isAdmin || this.settings.get('isMarkupAdmin') !== true,
            enableTax: true,
            showBilling: this.model.get('statusId') === PJQ.constants.primeContracts.changeOrderStatus.APPROVED,
            showSubTotal: true,
            showGrandTotal: true,
            onAccountingMethodChanged: _.bind(function (value) {
                this.model.set('accountingMethod', value);
            }, this),
            onLineItemChange: _.bind(function () {
                this.model.isDirty = true;
            }, this),
            onLineItemAdd: _.bind(function () {
                this.model.isDirty = true;
                this.updateCounts();
            }, this),
            onLineItemDelete: _.bind(function () {
                this.model.isDirty = true;
                this.updateCounts();
            }, this)
        });
    },
    viewPrimeContract: function () {
        this.removeModal();
        new PJQ.views.primeContracts.PrimeContractEditModal({
            model: new PJQ.models.primeContracts.PrimeContract({
                id: this.model.get('primeContractId')
            })
        });
    },
    checkFieldVisible: function (fieldName) {
        if (this.coreFieldSettings) {
            let fieldSettings = this.coreFieldSettings.findWhere({fieldName: fieldName});
            if (fieldSettings != null) {
                return fieldSettings.get('isVisible');
            }
        }
        return true;
    },
    checkFieldRequired: function (fieldName) {
        if (this.coreFieldSettings) {
            let fieldSettings = this.coreFieldSettings.findWhere({fieldName: fieldName});
            if (fieldSettings != null) {
                return fieldSettings.get('isRequired');
            }
        }
        return false;
    },
    viewHistory: async function () {
        let historyItems = [{
            date: this.model.get('createdOn'),
            person: this.model.get('createdBy'),
            action: 'Change Order Created'
        }];

        let history = new PJQ.collections.primeContracts.ChangeOrderHistory({}, {
            changeOrderId: this.model.id
        });
        new PJQ.views.history.HistoryTimelineModal({
            collection: history,
            subTitle: 'Contract Change Order #' + this.model.get('number'),
            items: historyItems
        });
    },
    exportChangeOrder: function (withMarkup = false) {
        let params = [];
        if (withMarkup === true) {
            params.push({
                parameter: 'withMarkup',
                value: true
            });
        }

        let callback = _.bind(function () {
            PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'primecontractchangeorders',
                    value: this.model.get('id')
                },
                {
                    endpoint: 'export',
                }
            ], params), {isAPIv2: true});
        }, this);

        if (this.options.canEdit && this.model.hasChanged()) {
            this.save(callback);
        } else {
            callback();
        }
    },
    exportChangeOrderWithMarkup: function () {
        this.exportChangeOrder(true);
    },
    validate: function () {
        let isValid = true;

        if (this.customFieldsForm != null && !this.customFieldsForm.validate())
            isValid = false;

        PJQ.helpers.inputHelpers.setInputError(this.$('.input-number'), true);
        if ((!this.model.isNew() || this.checkFieldRequired('number')) && _.size(this.model.get('number')) === 0) {
            isValid = false;
            PJQ.helpers.inputHelpers.setInputError(this.$('.input-number'), false);
        }

        if (this.checkFieldRequired('reviewer')) {
            if (!this.reviewerPicker.validate()) {
                isValid = false;
            }
        }

        if (this.checkFieldRequired('receivedFromId')) {
            if (!this.receivedFromPicker.validate()) {
                isValid = false;
            }
        }

        if (this.checkFieldRequired('changeReason')) {
            let $changeReason = this.$('.change-reason');
            PJQ.helpers.inputHelpers.setInputError($changeReason, true);
            if (_.size(this.model.get('changeReason')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($changeReason, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('invoicedDate')) {
            let $invoicedDate = this.$('.change-order-invoiced-date');
            PJQ.helpers.inputHelpers.setInputError($invoicedDate, true);
            if (this.model.get('invoicedDate') == null || this.model.get('invoicedDate').length === 0) {
                PJQ.helpers.inputHelpers.setInputError($invoicedDate, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('dueDate')) {
            let $dueDate = this.$('.change-order-due-date');
            PJQ.helpers.inputHelpers.setInputError($dueDate, true);
            if (this.model.get('dueDate') == null || this.model.get('dueDate').length === 0) {
                PJQ.helpers.inputHelpers.setInputError($dueDate, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('description')) {
            let $description = this.$('.change-order-description');
            PJQ.helpers.inputHelpers.setInputError($description, true);
            if (_.size(this.model.get('description')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($description, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('attachments')) {
            this.fileUploader.clearError();
            let hasValidAttachment = _.find(this.model.attachments.models, function (model) {
                return !model.get('delete')
            }, this) != null;

            if (!hasValidAttachment) {
                this.fileUploader.showError('Missing attachment', 100000);
                isValid = false;
            }
        }

        if (!isValid) {
            this.activateView(this.views.GENERAL);
        }

        isValid = this.lineItemsView.validate();
        if (!isValid) {
            this.activateView(this.views.LINEITEMS);
        }

        if (!this.lineItemsView.validate()) {
            isValid = false;

            if (this.options.activeView !== 'lineItems') {
                this.options.activeView = 'lineItems';
                this.$('.nav-tabs a[href="#PCCO_LineItems"]').tab('show');
            }
        }

        return isValid;
    },
    saveEmail: function () {
        this.save((success) => {
            if (success) {
                PJQ.notifications.notify.successNotify({
                    message: 'Contract Change Order saved successfully'
                });

                this.email();
            }
        });
    },
    saveChangeOrder: function () {
        this.save((success) => {
            if (success) {
                PJQ.notifications.notify.successNotify({
                    message: 'Contract Change Order saved successfully'
                });
                this.removeModal()
            }
        });
    },
    save: function (callback, closeChangeOrder = true) {
        if (!this.validate()) {
            this.$('.modal').prevObject.scrollTop(0);
            if (typeof callback === 'function') {
                callback(false);
            }
            return;
        }

        let newMarkupLines = this.model.lineItems.filter(function (lineItem) {
            return lineItem.markup && lineItem.isNew();
        });
        this.model.lineItems.remove(newMarkupLines);

        this.model.save({
            reviewer: this.reviewer ? this.reviewer.toJSON() : null,
            receivedFrom: this.receivedFrom ? this.receivedFrom.toJSON() : null,
            lineItems: this.model.lineItems.toJSON()
        }, {
            success: () => {
                this.render();
                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }

                this.options.project.trigger('contractCOChanged', this.model);
                if (typeof callback === 'function') {
                    callback(true);
                }
            },
            error: () => {
                if (typeof callback === 'function') {
                    callback(false);
                }
                PJQ.notifications.notify.errorNotify({
                    message: "Encountered an error while saving this Change Order. Please contact customer service."
                });
            }
        });
    },
    deleteChangeOrder: function () {
        let changeOrderId = this.model.id;
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Delete",
            body: "Are you sure you want to delete this change order?",
            onDelete: _.bind(function () {
                this.model.destroy({
                    success: _.bind(function () {
                        PJQ.notifications.notify.successNotify({
                            message: 'Change order deleted successfully'
                        });

                        if (typeof this.options.onDelete === 'function')
                            this.options.onDelete(changeOrderId);

                        this.removeModal();
                    }, this)
                });
            }, this)
        });
    },
    email: function () {
        let projectName = this.options.project?.get('projectName')?.trim();
        let subject = `A Change Order has been shared with you ${projectName && _.size(projectName) > 0 ? `for ${projectName}` : ''}`;
        new PJQ.views.email.ComposeEmailModal({
            header: "Email Contract Change Order",
            project: this.options.project,
            subject: subject,
            onSave: _.bind(function (data) {
                this.model.share(data, _.bind(function () {
                    PJQ.notifications.notify.successNotify({
                        message: 'Contract Change Order email sent'
                    });
                }, this));
            }, this)
        });
    },
    close: function () {
        if (this.model.hasChanged() && this.options.canEdit) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.saveChangeOrder();
                    this.removeModal();
                }, this),
                onDontSave: _.bind(function () {
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    }
});
PJQ.views.primeContracts.ChangeOrdersList = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PRIMECONTRACTS, 'prime-contract-change-orders-list'),
        changeOrderId: null
    },
    events: {
        'click .btn-settings': 'editSettings',
        'click .btn-add-change-order': 'newChangeOrder',
        'click .btn-view-change-order': 'viewChangeOrderClicked',
        'click .btn-delete-change-order': 'deleteChangeOrderClicked',
        'click .btn-export': 'exportChangeOrderList'
    },
    beforeFirstRender: async function () {
        this.isFetched = false;

        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;

        if (this.collection == null) {
            this.collection = new PJQ.collections.primeContracts.ChangeOrders(null, {
                projectId: this.options.project.get('projectId'),
                costCodeId: this.options.costCodeId ? this.options.costCodeId : null,
                costTypeId: this.options.costTypeId ? this.options.costTypeId : null
            });
        }

        if (!this.collection.isFetched) {
            await this.collection.fetch();
        }

        this.customFields = await this.options.project.fetchPrimeContractChangeOrderCustomFields();
        this.userSettings = await PJQ.app.session.fetchPrimeContractChangeOrderUserSettings();
        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();

        if (this.erpIntegration != null && this.erpIntegration.getSetting('syncProjects')) {
            await this.options.project.fetchERPObject();
        }

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.options.isAdmin = PJQ.app.session.project.hasPermission('primeContractChangeOrders.isAdmin');
    },
    renderData: function () {
        return {
            collection: this.collection,
            isFetched: this.isFetched
        }
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        this.renderView();

        PJQ.app.session.project.off('contractCOChanged');
        PJQ.app.session.project.on('contractCOChanged', function (changeOrder) {
            this.collection.add(changeOrder);
            this.render();
        }, this);

        if (this.options.changeOrderId > 0) {
            let initChangeOrder = this.collection.get(this.options.changeOrderId);
            if (initChangeOrder != null) {
                this.viewChangeOrder(initChangeOrder);
                this.options.changeOrderId = null;
            }
        }
    },
    renderView: function () {
        if (this.dataTable) {
            this.dataTable.remove();
            this.dataTable = null;
        }

        this.dataTable = this.getDataTableInstance();
    },
    getDataTableInstance: function () {
        return new PJQ.views.primeContracts.ChangeOrderDataTable({
            el: this.$('.change-orders-data'),
            rowId: "cid",
            data: this.collection.models,
            onPageSizeChange: function (value) {
                // PJQ.helpers.cookieHelpers.setCookie(PJQ.constants.cookies.RFI_PAGE_LENGTH, value);
            },
            isAdmin: this.options.isAdmin,
            statusIds: this.options.statusIds,
            headerData: _.bind(function () {
                return {
                    project: this.options.project,
                    isAdmin: this.options.isAdmin
                };
            }, this),
            userSettings: this.userSettings,
            settings: this.userSettings.getSettings(PJQ.constants.primeContracts.view.CHANGE_ORDERS),
            order: [[1, 'asc']],
            colReorder: {
                fixedColumnsLeft: 1,
                fixedColumnsRight: 1,
                realtime: false
            },
            columnOrderChanged: _.bind(function () {
                this.userSettings.save();
            }, this),
            onRowDoubleClick: _.bind(function (row) {
                this.viewChangeOrder(row.data());
            }, this),
            contextMenuOptions: {
                actions: [
                    {
                        name: 'View',
                        onClick: _.bind(function (row) {
                            this.viewChangeOrder(row.data());
                        }, this)
                    }
                ]
            }
        });
    },
    exportChangeOrderList: function () {
        let parameters = [
            {
                parameter: 'timeZoneOffset',
                value: new Date().getTimezoneOffset()
            }
        ];

        PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: PJQ.app.session.project.id
            },
            {
                endpoint: 'primecontractchangeorders'
            },
            {
                endpoint: 'export'
            }
        ], parameters), {isAPIv2: true});
    },
    newChangeOrder: function (e) {
        this.viewChangeOrder();
    },
    viewChangeOrderClicked: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr'));
        this.viewChangeOrder(row.data());
    },
    viewChangeOrder: function (changeOrder) {
        let isNew = changeOrder == null
        new PJQ.views.primeContracts.ChangeOrderEditModal({
            model: changeOrder,
            onSave: _.bind(function (changeOrder) {
                if (isNew) {
                    this.collection.add(changeOrder);
                }
                this.renderView();
            }, this),
            onDelete: _.bind(function (changeOrder) {
                this.collection.remove(changeOrder);
                this.renderView();
            }, this)
        });
    },
    deleteChangeOrderClicked: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr'));
        this.deleteChangeOrder(row);
    },
    deleteChangeOrder: function (row) {
        if (row != null) {
            let changeOrder = row.data();
            if (changeOrder != null) {
                new PJQ.views.modals.DeleteCancel({
                    header: "Delete Change Order",
                    body: "Are you sure you want to delete this Change Order?",
                    onDelete: _.bind(function () {
                        changeOrder.destroy({
                            success: _.bind(function () {
                                this.dataTable.removeRow(row);
                                if (typeof this.options.onDelete === 'function') {
                                    this.options.onDelete(changeOrder);
                                }
                            }, this)
                        });
                    }, this)
                });
            }
        }
    },
    editSettings: function () {
        new PJQ.views.primeContracts.ChangeOrderSettingsModal({
            changeOrdersView: this,
            onSave: _.bind(function () {
                this.renderView();
                PJQ.notifications.notify.successNotify({
                    message: 'Settings updated successfully'
                });
            }, this)
        });
    }
});

PJQ.views.primeContracts.ModalViewChangeOrders = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PRIMECONTRACTS, 'modal-view-change-orders'),
        maxWidth: 1000,
        isShowCloseButton: true,
        onSave: _.noop,
        isAdmin: true
    },
    events: {},
    beforeModalCreated: function () {

    },
    renderData: function () {
        return {
            model: this.model
        }
    },
    afterRender: function () {
        if (this.model != null) {
            new PJQ.views.primeContracts.ChangeOrdersList({
                el: this.$('.modal-body'),
                model: this.model,
                costCodeId: this.model.get('costCodeId'),
                costTypeId: this.model.get('costTypeId'),
                statusIds: this.options.statusIds,
                project: this.options.project
            })
        }
    },
});

PJQ.views.primeContracts.SelectChangeOrdersModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PRIMECONTRACTS, 'modal-select-change-orders'),
        width: '50%',
        maxWidth: 700,
        onSave: _.noop,
        headerSubText: null
    },
    events: {
        "change .select-change-order": "selectChangeOrder",
        "click .btn-save": "save",
        "click .btn-cancel": "cancel"
    },
    beforeModalCreated: async function () {
        this.isFetched = false;
        this.options.isAdmin = PJQ.app.session.project.hasPermission('primeContractChangeOrders.isAdmin');
        this.selectedCids = [];

        if (this.collection == null) {
            this.collection = new PJQ.collections.primeContracts.ChangeOrders(null, {
                projectId: this.options.project.get('projectId')
            });
        }

        if (!this.collection.isFetched) {
            await this.collection.fetch();
        }

        this.isFetched = true;
        this.render();
    },
    renderData: function () {
        return {
            headerSubText: this.options.headerSubText,
            isSingleChoice: this.options.isSingleChoice
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        let data;
        if (this.options.filterStatuses != null) {
            data = _.filter(this.collection.models, function (model) {
                let statusId = model.get('statusId');

                if (_.isArray(this.options.filterStatuses)) {
                    return _.includes(this.options.filterStatuses, statusId);
                } else if (_.isNumber(this.options.filterStatuses)) {
                    return this.options.filterStatuses === statusId;
                }

                return false;

            }, this);
        } else {
            data = this.collection.models;
        }

        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.change-orders-table'),
            data: data,
            isHideSearch: true,
            order: [],
            columns: [{
                "data": "id",
                "title": "",
                "orderable": false,
                "searchable": false,
                "render": _.bind(function (data, type, row) {
                    let selected = this.selectedCids.indexOf(row.cid) !== -1
                    return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox" ' + (selected ? 'checked' : '') + ' class="select-change-order"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                }, this)
            },
                {
                    "data": "attributes.number",
                    "title": "Number",
                    "orderable": true
                },
                {
                    "data": "attributes.description",
                    "title": "Description",
                    "orderable": false
                },
                {
                    "data": "attributes.amount",
                    "title": "Amount",
                    "orderable": false,
                    "className": "text-align-right",
                    "render": _.bind(function (data, type, row) {
                        return PJQ.helpers.formatHelpers.formatCurrency(row.getGrandTotal());
                    }, this)
                }],
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>'
        });
    },
    selectChangeOrder: function (e) {
        let $target = $(e.currentTarget),
            changeOrder = this.dataTable.getRow($target.closest('tr')).data(),
            isSelected = $target.prop('checked');
        if (this.options.isSingleChoice) {
            this.selectedCids = isSelected ? [changeOrder.cid] : [];
        } else {
            if (isSelected) {
                this.selectedCids.push(changeOrder.cid);
            } else {
                this.selectedCids = _.without(this.selectedCids, changeOrder.cid);
            }
        }

        if (typeof this.options.onSelected === 'function') {
            this.options.onSelected(this.selectedPrimeContract);
        }

        this.dataTable.refresh();

        this.$('.btn-save').prop('disabled', _.size(this.selectedCids) === 0);
    },
    getSelected: function () {
        if (this.options.isSingleChoice) {
            if (_.size(this.selectedCids) === 0) {
                return null;
            }
            return this.collection.get(this.selectedCids[0]);
        }

        return _.filter(this.collection.models, (model) => {
            return this.selectedCids.indexOf(model.cid) !== -1;
        });
    },
    cancel: function () {
        if (this.options.onCancel) {
            this.options.onCancel();
        }
        this.removeModal();
    },
    save: function () {
        if (this.options.onSave) {
            this.options.onSave(this.getSelected());
            this.removeModal();
        }
    }
});
//Models
PJQ.models.primeContracts.ChangeOrder = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        let arr = [];
        if (this.isNew()) {
            arr.push({
                endpoint: 'projects',
                value: this.get('projectId')
            });
        }
        arr.push({
            endpoint: 'primecontractchangeorders',
            value: this.id
        });
        return PJQ.helpers.urlHelpers.generateEndpoint(arr);
    },
    parse: function (model) {
        if (!model)
            return model;

        if (model.primeContract) {
            this.primeContract = model.primeContract;
        }

        this.lineItems = new PJQ.collections.primeContracts.ChangeOrderLineItems(model.lineItems);
        this.attachments = new PJQ.collections.primeContracts.ChangeOrderAttachments(model.attachments);
        this.invoices = new PJQ.collections.invoicing.ReceivableInvoices(model.invoices);

        this.markupItems = new PJQ.financialMarkups.collections.FinancialMarkups(model ? model.markupItems : null);

        if (model && model.client) {
            if (model.client instanceof PJQ.models.BaseModel) {
                this.client = model.client;
            } else {
                this.client = new PJQ.models.contacts.Contact(model.client);
            }
        }

        if (model && model.reviewer) {
            if (model.reviewer instanceof PJQ.models.BaseModel) {
                this.reviewer = model.reviewer;
            } else {
                this.reviewer = new PJQ.models.contacts.Contact(model.reviewer);
            }
        }

        if (model && model.receivedFrom) {
            if (model.receivedFrom instanceof PJQ.models.BaseModel) {
                this.receivedFrom = model.receivedFrom;
            } else {
                this.receivedFrom = new PJQ.models.contacts.Contact(model.receivedFrom);
            }
        }

        return model;
    },
    beforeSave: function () {
        let newMarkupLines = this.lineItems.filter(function (lineItem) {
            return lineItem.markup && lineItem.isNew();
        });
        this.lineItems.remove(newMarkupLines);

        this.set({
            lineItems: this.lineItems.toJSON(),
            attachments: this.attachments.toJSON(),
            markupItems: this.markupItems.toJSON()
        });
    },
    syncERP: function (callback) {
        return PJQ.models.primeContracts.PrimeContract.prototype.syncERP.call(this, callback);
    },
    makeERPUrl: function (integration) {
        return PJQ.models.primeContracts.PrimeContract.prototype.makeERPUrl.call(this, integration);
    },
    share: function (data, callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/email',
            isAPIv2: true,
            data: {
                subject: data != null ? data.subject : null,
                body: data != null ? data.body : null,
                toEmails: data != null ? data.toEmails : null,
                ccEmails: data != null ? data.ccEmails : null,
            }
        }).post().done(_.bind(function (response) {
            callback();
        }, this)).fail(_.bind(function (xhr, err, result) {
            //todo: error
        }, this));
    },
    getSubTotal: function () {
        return this.get('amount') + this.get('markupAmount');
    },
    getGrandTotal: function () {
        return this.getSubTotal() + this.get('taxAmount');
    }
});

PJQ.models.primeContracts.ChangeOrderHistoryItem = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    actionNames: {
        'status': 'Status Changed',
        'submit': 'Submitted',
        'email': 'Email Sent'
    },
    getActionName: function () {
        return this.actionNames[this.get('action')] ?? this.get('action');
    },
    getDescription: function () {
        switch (this.get('action')) {
            case 'status':
                let fromStatus = this.get('data').from,
                    toStatus = this.get('data').to;
                if (fromStatus == null || toStatus == null) {
                    return '';
                }

                return '' + PJQ.constants.primeContracts.changeOrderStatusNames[fromStatus] + '<i class="fal fa-arrow-right ml-1 mr-1 fs-14"></i>' + PJQ.constants.primeContracts.changeOrderStatusNames[toStatus];
            case 'email':
                let to = this.get('data').to;
                if (_.size(to) === 0) {
                    return '';
                }

                return 'To: ' + to.join(', ');
            default:
                return '';
        }
    }
});

PJQ.models.primeContracts.ChangeOrderAttachment = PJQ.models.files.File.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id'
});

PJQ.models.primeContracts.ChangeOrderLineItem = PJQ.models.budget.BaseLineItem.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id'
});

PJQ.models.primeContracts.ChangeOrderCustomField = PJQ.models.customFields.CustomField.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'primecontractchangeorders'
            },
            {
                endpoint: 'customfields',
                value: this.get('id')
            }
        ]);
    }
});

PJQ.models.primeContracts.ChangeOrderSettings = PJQ.models.budget.Settings.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    endpoint: function () {
        if (this.options.projectId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'primecontractchangeorders'
                },
                {
                    endpoint: 'settings'
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'primecontractchangeorders'
            },
            {
                endpoint: 'settings'
            }
        ]);
    }
});

PJQ.models.primeContracts.ChangeOrderUserSettings = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'primecontractchangeorders'
            },
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'user'
            }
        ]);
    },
    getSettings: function (view) {
        return _.find(this.attributes.viewSettings, _.bind(function (setting) {
            return setting.view === view;
        }, this));
    }
});

PJQ.models.primeContracts.ChangeOrderFieldSetting = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'fields',
                value: this.id ? this.id : 'primecontractchangeorders'
            }
        ]);
    }
});

//Collections
PJQ.collections.primeContracts.ChangeOrders = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.primeContracts.ChangeOrder,
    endpoint: function () {
        let params = [];
        if (this.options.costCodeId && this.options.costTypeId) {
            params.push({
                parameter: 'costCodeId',
                value: this.options.costCodeId
            }, {
                parameter: 'costTypeId',
                value: this.options.costTypeId
            });
        }
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.projectId
            },
            {
                endpoint: 'primecontractchangeorders'
            }
        ], params);
    },
    getTotalAmountsByStatus: function () {
        let result = {};
        _.each(PJQ.constants.primeContracts.changeOrderStatusBuckets, function (bucket) {
            let total = 0;
            _.each(this.models, function (changeOrder) {
                if (bucket.statuses.indexOf(changeOrder.get('statusId')) !== -1) {
                    total += changeOrder.get('totalAmount');
                }
            });
            result[bucket.name] = total;
        }, this);
        return result;
    }
});

PJQ.collections.primeContracts.ChangeOrderHistory = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.primeContracts.ChangeOrderHistoryItem,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'primecontractchangeorders',
                value: this.options.changeOrderId
            },
            {
                endpoint: 'history'
            }
        ]);
    }
});

PJQ.collections.primeContracts.ChangeOrderLineItems = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.primeContracts.ChangeOrderLineItem,
    endpoint: function () {
        let params = [];
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'primecontractchangeorders',
                value: this.options.changeOrderId
            },
            {
                endpoint: 'lineitems'
            }
        ], params);
    }
});


PJQ.collections.primeContracts.ChangeOrderAttachments = PJQ.collections.files.Files.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.primeContracts.ChangeOrderAttachment,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'primecontractchangeorders',
                value: this.options.changeOrderId
            },
            {
                endpoint: 'attachments'
            }
        ]);
    }
});

PJQ.collections.primeContracts.ChangeOrderCustomFields = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.primeContracts.ChangeOrderCustomField,
    endpoint: function () {
        if (this.options.projectId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'primecontractchangeorders'
                },
                {
                    endpoint: 'customfields'
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'primecontractchangeorders'
            },
            {
                endpoint: 'customfields'
            }
        ]);
    }
});

PJQ.collections.primeContracts.ChangeOrderFieldSettings = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.primeContracts.ChangeOrderFieldSetting,
    endpoint: function () {
        if (this.options.projectId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'settings'
                },
                {
                    endpoint: 'fields',
                    value: 'primecontractchangeorders'
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'fields',
                value: 'primecontractchangeorders'
            }
        ]);
    }
});
PJQ.views.primeContracts.ChangeOrderSettingsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PRIMECONTRACTS, 'modal-change-order-settings'),
        minWidth: '600px',
    },
    events: {
        'change .select-column': 'columnSelected',
        'click .btn-edit-company-default': 'editCompanySettings',
        'click button.settings-save': 'onSave'
    },
    beforeModalCreated: function () {
        this.userSettings = this.options.changeOrdersView.userSettings;
        this.customFields = this.options.changeOrdersView.customFields;
    },
    beforeRender: function () {
        // copy userSettings for our UI; we only update global userSettings object on save.
        this.options.userSettings = [];

        this.options.defaultStatusFilter = this.userSettings.get('defaultStatusFilter');
        _.each(this.userSettings.attributes.viewSettings, _.bind(function (setting) {
            let columns = this.options.changeOrdersView.dataTable.getColumns(true),
                selectedColumns = (_.size(setting.columns) > 0) ? setting.columns : setting.columnsDefault;
            _.each(columns, _.bind(function (column) {
                column.visible = selectedColumns.indexOf(column.columnData) !== -1
            }, this));

            this.options.userSettings.push({
                view: setting.view,
                rowsPerPage: setting.rowsPerPage,
                columns: columns
            });
        }, this));
    },
    renderData: function () {
        return {
            userSettings: this.userSettings
        }
    },
    afterRender: function () {
        let defaultFilter = {};
        defaultFilter[PJQ.constants.primeContracts.changeOrderFilterType.STATUS_FILTER] = this.userSettings.get('defaultStatusFilter');

        this.defaultFilterSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-filter-default'),
            isIntChoices: true,
            isMultiple: true,
            isGrouped: true,
            mustSelectValuePerOptGroup: true,
            defaultValue: defaultFilter,
            onHide: _.bind(function () {
                this.options.defaultStatusFilter = this.defaultFilterSelectPicker.getValue()[PJQ.constants.primeContracts.changeOrderFilterType.STATUS_FILTER];
            }, this)
        });

        this.rowsPerPage = new PJQ.inputs.Selectpicker({
            el: this.$('select.rows-per-page'),
            isIntChoices: true,
            onChange: _.bind(function (value) {
                this.currentView.rowsPerPage = value;
            }, this)
        });

        this.selectView(PJQ.constants.primeContracts.view.CHANGE_ORDERS);
    },
    editCompanySettings: function () {
        this.userSettings = new PJQ.models.primeContracts.ChangeOrderUserSettings(null, {
            forCompany: true
        });
        this.userSettings.fetch({
            success: _.bind(function () {
                this.render();
            }, this)
        });
    },
    selectView: function (view) {
        this.currentView = _.find(this.options.userSettings, _.bind(function (setting) {
            return setting.view === view;
        }, this));

        this.rowsPerPage.setValue(this.currentView.rowsPerPage);

        if (this.dataTable) {
            this.dataTable.undelegateEvents();
            $(this.dataTable.el).empty();
        }

        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('div.select-columns-datatable'),
            data: this.currentView.columns,
            isHideSearch: true,
            pageLength: 6,
            order: [],
            columns: [
                {"data": "title", "title": "Column", "orderable": false},
                {
                    "data": "visible",
                    "title": "Show",
                    "orderable": false,
                    "searchable": false,
                    "render": _.bind(function (data) {
                        return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox"' + (data ? ' checked ' : '') + 'class="select-column"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                    }, this),
                    "width": '10%'
                }
            ],
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>'
        });

    },
    columnSelected: function (sender) {
        this.dataTable.dataTable.row($(sender.currentTarget).closest('tr')).data().visible = $(sender.currentTarget).prop('checked');
    },
    onSave: function () {
        let fnOnSave = _.bind(function () {
            if (typeof this.options.onSave === 'function')
                this.options.onSave();
            this.removeModal();
        }, this);

        this.userSettings.set('defaultStatusFilter', this.options.defaultStatusFilter);

        _.each(this.options.userSettings, _.bind(function (settingTemp) {
            _.each(this.userSettings.get('viewSettings'), _.bind(function (setting) {
                if (settingTemp.view === setting.view) {
                    setting.rowsPerPage = settingTemp.rowsPerPage;

                    let columns = _.size(setting.columns) > 0 ? setting.columns.slice() : setting.columnsDefault.slice();

                    // update columns
                    _.each(settingTemp.columns, _.bind(function (column) {
                        if (column.visible) {
                            if (columns.indexOf(column.columnData) === -1)
                                columns.push(column.columnData);
                        }
                        else {
                            if (columns.indexOf(column.columnData) !== -1)
                                columns = _.filter(columns, _.bind(function (columnTemp) {
                                    return columnTemp != column.columnData;
                                }, this));
                        }
                    }, this));

                    setting.columns = columns;
                }
            }, this));
        }, this));

        this.userSettings.save(null, {
            success: _.bind(function () {
                fnOnSave();
            }, this)
        });
    },
});
PJQ.views.primeContracts.PrimeContractDataTable = PJQ.views.dataTables.DataTable.extend({
    defaults: {
        language: {
            emptyTable: 'No Contracts have been created yet',
            zeroRecords: "No Contracts matched the search criteria"
        },
        subTemplates: {
            header: new PJQ.templating.Template(PJQ.constants.modules.PRIMECONTRACTS, 'data-table-header-prime-contracts')
        },
        toggleRowClass: '.change-order-toggle-row'
    },
    events: {},
    beforeDataTableRender: function () {
        this.options.pageLength = this.options.settings ? this.options.settings.rowsPerPage : 10;
    },
    getDefaultFilter: function () {
        return _.size(this.options.statusIds) > 0 ? this.options.statusIds : this.options.userSettings.get('defaultPrimeContractStatusFilter');
    },
    afterHeaderRender: function () {
        new PJQ.inputs.Selectpicker({
            el: this.$('.prime-contracts-status-filter'),
            defaultValue: this.getDefaultFilter(),
            isIntChoices: true,
            isMultiple: true,
            noneSelectedText: 'No Filters',
            onChange: _.bind(function (value) {
                this.setFilter(PJQ.constants.primeContracts.filterType.PRIME_CONTRACT_STATUS_FILTER, value);
            }, this)
        });
        this.setFilter(PJQ.constants.primeContracts.filterType.PRIME_CONTRACT_STATUS_FILTER, this.getDefaultFilter());
    },
    getFilterData: function () {
        let statusFilter = this.getFilter(PJQ.constants.primeContracts.filterType.PRIME_CONTRACT_STATUS_FILTER);
        if (_.size(statusFilter) === 0) {
            return this.options.data;
        }

        return _.filter(this.options.data, function (row) {
            return (_.size(statusFilter) === 0 || _.contains(statusFilter, row.get('statusId')));
        });
    },
    getColumns: function (includeAllColumns = false) {
        this.options.canViewPrimeContracts = PJQ.app.session.project.hasPermission('primeContracts.canView');

        let columns = [],
            includeColumns = ['status', 'number', 'description', 'createdOn', 'startOn', 'estimatedCompleteOn', 'substantialCompleteOn', 'actualCompleteOn', 'contractOn', 'signedContractOn', 'executedOn', 'issuedOn', 'returnedOn', 'letterOfIntentOn', 'approvalLetterOn', 'contractTerminatedOn', 'inclusions', 'exclusions', 'isExecuted', 'amount', 'taxAmount', 'grandTotal', 'approvedChanges', 'contractTotal', 'progressAmount', 'amountRemaining'];

        if (this.options.customFields) {
            _.each(this.options.customFields.models, _.bind(function (customField) {
                includeColumns.push('fieldValue' + customField.get('fieldNumber'));
            }, this));
        }

        if (!includeAllColumns) {
            if (this.options.settings && _.size(this.options.settings.columns) > 0)
                includeColumns = this.options.settings.columns;
            else
                includeColumns = this.options.settings && this.options.settings.columnsDefault ? this.options.settings.columnsDefault : includeColumns;

            columns.push({
                "columnData": "childData",
                "data": null,
                "title": "",
                "width": "20px",
                "orderable": false,
                "searchable": false,
                "defaultContent": '',
                "render": (data, type, row) => {
                    if (!this.options.isAdmin) {
                        return "";
                    }

                    let exObj = row.get('externalObject');
                    if (exObj == null) {
                        return '';
                    }

                    return PJQ.helpers.erp.getERPBadge(exObj.status, exObj);
                }
            });
        }

        _.each(includeColumns, _.bind(function (columnName) {
            switch (columnName) {
                case 'status':
                    columns.push({
                        "columnData": "status",
                        "data": "attributes.statusId",
                        "title": "Status",
                        "width": "120px",
                        "render": (data, type, row) => {
                            return PJQ.constants.primeContracts.primeContractStatusNames[row.get('statusId')];
                        }
                    });
                    break;
                case 'number':
                    columns.push({
                        "columnData": "number",
                        "data": "attributes.number",
                        "title": "Number",
                        "width": "200px",
                        "render": _.bind(function (data, type, row) {
                            if (type === 'sort' || type === 'type') {
                                return row.get('number');
                            }
                            return `<a href="javascript:void(0)" class="btn-view-prime-contract">${data}</a>`;
                        }, this)
                    });
                    break;
                case 'description':
                    columns.push({
                        "columnData": "description",
                        "data": "attributes.description",
                        "title": "Description"
                    });
                    break;
                case 'createdOn':
                    columns.push({
                        "columnData": "createdOn",
                        "data": "attributes.createdOn",
                        "title": 'Created',
                        "width": '120px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                        }, this)
                    });
                    break;
                case 'startOn':
                    columns.push({
                        "columnData": "startOn",
                        "data": "attributes.startOn",
                        "title": 'Start',
                        "width": '120px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'estimatedCompleteOn':
                    columns.push({
                        "columnData": "estimatedCompleteOn",
                        "data": "attributes.estimatedCompleteOn",
                        "title": 'Est. Complete',
                        "width": '120px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'substantialCompleteOn':
                    columns.push({
                        "columnData": "substantialCompleteOn",
                        "data": "attributes.substantialCompleteOn",
                        "title": 'Substantial Complete',
                        "width": '120px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'actualCompleteOn':
                    columns.push({
                        "columnData": "actualCompleteOn",
                        "data": "attributes.actualCompleteOn",
                        "title": 'Act. Complete',
                        "width": '120px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'contractOn':
                    columns.push({
                        "columnData": "contractOn",
                        "data": "attributes.contractOn",
                        "title": 'Contract Date',
                        "width": '120px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'signedContractOn':
                    columns.push({
                        "columnData": "signedContractOn",
                        "data": "attributes.signedContractOn",
                        "title": 'Signed Date',
                        "width": '120px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'executedOn':
                    columns.push({
                        "columnData": "executedOn",
                        "data": "attributes.executedOn",
                        "title": 'Execution Date',
                        "width": '120px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'issuedOn':
                    columns.push({
                        "columnData": "issuedOn",
                        "data": "attributes.issuedOn",
                        "title": 'Issued On',
                        "width": '120px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'returnedOn':
                    columns.push({
                        "columnData": "returnedOn",
                        "data": "attributes.returnedOn",
                        "title": 'Returned On',
                        "width": '120px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'letterOfIntentOn':
                    columns.push({
                        "columnData": "letterOfIntentOn",
                        "data": "attributes.letterOfIntentOn",
                        "title": 'Letter of Intent',
                        "width": '120px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'approvalLetterOn':
                    columns.push({
                        "columnData": "approvalLetterOn",
                        "data": "attributes.approvalLetterOn",
                        "title": 'Approval Letter',
                        "width": '120px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'contractTerminatedOn':
                    columns.push({
                        "columnData": "contractTerminatedOn",
                        "data": "attributes.contractTerminatedOn",
                        "title": 'Termination Date',
                        "width": '120px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'inclusions':
                    columns.push({
                        "columnData": "inclusions",
                        "data": "attributes.inclusions",
                        "title": "Inclusions"
                    });
                    break;
                case 'exclusions':
                    columns.push({
                        "columnData": "exclusions",
                        "data": "attributes.exclusions",
                        "title": "Exclusions"
                    });
                    break;
                case 'isExecuted':
                    columns.push({
                        "columnData": "isExecuted",
                        "data": "attributes.isExecuted",
                        "title": "Executed"
                    });
                    break;
                case 'amount':
                    columns.push({
                        "columnData": "amount",
                        "data": "attributes.amount",
                        "title": "Amount",
                        "width": "120px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(data);
                        }, this)
                    });
                    break;
                case 'taxAmount':
                    columns.push({
                        "columnData": "taxAmount",
                        "data": "attributes.taxAmount",
                        "title": "Tax",
                        "width": "120px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(data);
                        }, this)
                    });
                    break;
                case 'originalContract':
                    columns.push({
                        "columnData": "originalContract",
                        "data": "attributes.amount",
                        "title": "Contract Total",
                        "width": "120px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.getGrandTotal());
                        }, this)
                    });
                    break;
                case 'approvedChanges':
                    columns.push({
                        "columnData": "approvedChanges",
                        "data": "attributes.approvedChanges",
                        "width": "120px",
                        "title": "Approved Changes",
                        "className": "text-align-right",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.get('approvedChanges'));
                        }, this)
                    });
                    break;
                case 'contractTotal':
                    columns.push({
                        "columnData": "contractTotal",
                        "data": "attributes.amount",
                        "width": "120px",
                        "title": "Contract Total",
                        "className": "text-align-right",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.getGrandTotal() + row.get('approvedChanges'));
                        }, this)
                    });
                    break;
                case 'progressAmount':
                    columns.push({
                        "columnData": "progressAmount",
                        "data": "attributes.progressAmount",
                        "width": "120px",
                        "title": "Billed to Date",
                        "className": "text-align-right",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.get('progressAmount') + row.get('progressTaxAmount') - row.get('retainageAmount') + row.get('retainageReleasedAmount'));
                        }, this)
                    });
                    break;
                case 'amountRemaining':
                    columns.push({
                        "columnData": "amountRemaining",
                        "data": "attributes.amountRemaining",
                        "width": "120px",
                        "title": "Amount Remaining",
                        "className": "text-align-right",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.get('amount') + row.get('approvedChanges') - row.get('progressAmount'));
                        }, this)
                    });
                    break;
                default:
                    if (columnName.startsWith('fieldValue')) {
                        _.each(this.customFields.models, function (customField) {
                            if (columnName === 'fieldValue' + customField.get('fieldNumber')) {
                                columns.push({
                                    "columnData": 'fieldValue' + customField.get('fieldNumber'),
                                    "title": customField.get('name'),
                                    "render": function (data, type, row) {
                                        let fieldValue = row.getCustomFieldValue(customField.get('id'));
                                        fieldValue = (fieldValue !== null) ? fieldValue : '';
                                        switch (customField.get('fieldTypeId')) {
                                            case PJQ.constants.commitments.customFieldType.BOOLEAN:
                                                if (fieldValue != null)
                                                    fieldValue = fieldValue ? 'Yes' : 'No';
                                                break;
                                            case PJQ.constants.commitments.customFieldType.CHOICE:
                                                let choices = [];
                                                // convert single choice value into array so that the logic below can work for both types.
                                                if (typeof fieldValue === 'number')
                                                    fieldValue = [fieldValue];

                                                _.each(customField.choices.models, _.bind(function (choice) {
                                                    if (_.find(fieldValue, function (value) {
                                                        return value === choice.get('id');
                                                    }))
                                                        choices.push(choice.get('name'));
                                                }, this));

                                                fieldValue = choices.join((', '));
                                                break;
                                            case PJQ.constants.commitments.customFieldType.DATE:
                                                if (fieldValue) {
                                                    if (type !== 'sort' && type !== 'type')
                                                        fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                                                }
                                                if (fieldValue === undefined)
                                                    fieldValue = '';

                                                break;
                                            case PJQ.constants.commitments.customFieldType.DATETIME:
                                                if (fieldValue) {
                                                    if (type !== 'sort' && type !== 'type')
                                                        fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                                                }
                                                if (fieldValue === undefined)
                                                    fieldValue = '';

                                                break;
                                            case PJQ.constants.commitments.customFieldType.INTEGER:
                                                if (type !== 'sort' && type !== 'type' && fieldValue) {
                                                    fieldValue = parseInt(fieldValue).toLocaleString();
                                                }
                                                break;
                                            case PJQ.constants.commitments.customFieldType.MONEY:
                                                if (type === 'sort' || type === 'type') {
                                                    if (fieldValue && fieldValue !== '$')
                                                        fieldValue = parseFloat(PJQ.helpers.formatHelpers.numbersOnly(fieldValue, true));
                                                    else
                                                        fieldValue = 0;
                                                } else {
                                                    fieldValue = PJQ.helpers.formatHelpers.formatCurrency(parseInt(PJQ.helpers.formatHelpers.numbersOnly(fieldValue)));
                                                }
                                                break;
                                            case PJQ.constants.commitments.customFieldType.PERCENT:
                                                if (type === 'sort' || type === 'type') {
                                                    if (fieldValue && fieldValue !== '$')
                                                        fieldValue = parseFloat(PJQ.helpers.formatHelpers.numbersOnly(fieldValue / 100, true)).toFixed(2)
                                                    else
                                                        fieldValue = 0;
                                                } else {
                                                    fieldValue = fieldValue ? parseFloat(PJQ.helpers.formatHelpers.numbersOnly(fieldValue / 100, true)).toFixed(2) + '%' : '';
                                                }

                                                break;
                                        }
                                        return fieldValue;
                                    }
                                });
                            }
                        });
                    }
                    break;
            }
        }, this));

        if (!includeAllColumns) {
            columns.push({
                "title": '',
                "render": _.bind(function (data, type, row) {
                    let html = '<div class="show-on-row-hover">',
                        status = row.get('statusId');
                    if (this.options.canViewPrimeContracts) {
                        html += '<button type="button" class="btn btn-info btn-view-prime-contract ml-1" title="View contract"><i class="fal fa-arrow-alt-from-left"></i></button>';
                    }
                    if (status !== PJQ.constants.primeContracts.primeContractStatus.TERMINATED) {
                        // html += '<button type="button" class="btn btn-success btn-add-change-order ml-1" title="New Change Order"><i class="fal fa-arrow-right-arrow-left"></i></button>';
                    }
                    html += '</div>'
                    return html
                }, this),
                "orderable": false,
                "searchable": false,
                "width": "90px",
                "className": "text-center",
                "visible": true
            });
        }

        return columns;
    },
    getRowChildTable: function (childOpts) {
        childOpts.parentDataTable = this;
        childOpts.dom = 't';
        return new PJQ.views.commitments.LineItemDataTable(childOpts);
    },
    getRowChildData: function (row) {
        return new PJQ.collections.primeContracts.LineItems(null, {
            primeContractId: row.data().id
        });
    }
});
PJQ.views.primeContracts.PrimeContractEditModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PRIMECONTRACTS, 'modal-prime-contract-edit'),
        width: '95%',
        maxWidth: 1500,
        isShowCloseButton: true,
        onSave: _.noop,
        isAdmin: true,
        canEdit: true
    },
    events: {
        'keydown .input-percent': 'numbersOnly',
        'change .input-percent': 'formatPercent',
        'click .btn-save-email': 'saveEmail',
        'click .btn-save': 'savePrimeContract',
        'click .btn-push-erp': 'pushERP',
        'click .btn-undo-push-erp': 'undoPushERP',
        'click .btn-unlink-erp': 'unlinkERP',
        'click .btn-delete': 'deletePrimeContract',
        'click .btn-close': 'close',
        'click .btn-export': 'exportPrimeContract',
        'click .btn-export-markup': 'exportPrimeContractWithMarkup',
        'click .btn-email': 'email',
        'click .btn-new-change-order': 'newChangeOrder',
        'click .btn-view-change-order': 'viewChangeOrderClicked',
        'click .btn-view-invoice': 'viewInvoiceClicked',
        'click .btn-new-invoice': 'newInvoice',
        'click .btn-view-payment': 'viewPaymentClicked',
        'click .nav-link': 'activeViewChanged',
        'click .btn-view-history': 'viewHistory'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;

        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;
        this.coreFieldSettings = await this.options.project.fetchPrimeContractFieldSettings();
        this.terms = await this.options.project.fetchPrimeContractTerms();
        this.settings = await this.options.project.fetchPrimeContractSettings();
        this.customFields = await this.options.project.fetchPrimeContractCustomFields();
        this.invoiceSettings = await this.options.project.fetchReceivableInvoiceSettings();
        this.costCodes = this.options.project.fetchCostCodes();
        this.costTypes = this.options.project.fetchCostTypes();
        this.unitsOfMeasure = this.options.project.fetchUnitsOfMeasure();
        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();
        this.uploadCustomFields = _.filter(this.customFields.models, function (model) {
            return model.get('fieldTypeId') === 13;
        }, this);

        if (this.erpIntegration != null && this.erpIntegration.getSetting('syncProjects')) {
            await this.options.project.fetchERPObject();
        }

        if (this.model == null) {
            let customFieldValues = [];
            _.each(this.customFields.models, (model, index) => {
                let value = model.get('defaultValue') ? model.get('defaultValue') : '';
                if (model.get('fieldType') === 'CHOICE') {
                    value = parseInt(value);
                }
                customFieldValues.push({
                    fieldNumber: model.get('fieldNumber'),
                    fieldTypeId: model.get('fieldTypeId'),
                    fieldType: model.get('fieldType'),
                    isMultiple: model.get('isMultiple'),
                    value: value,
                    id: model.get('id')
                })
            });

            this.model = new PJQ.models.primeContracts.PrimeContract({
                accountingMethod: this.settings.get('defaultAccountingMethod'),
                projectId: PJQ.app.session.project.id,
                statusId: PJQ.constants.primeContracts.primeContractStatus.DRAFT,
                createdOn: new Date(Date.now()),
                customFieldValues: customFieldValues
            });
        }

        if (!this.model.isNew()) {
            await this.model.fetch();
        }

        this.hasChangeRequests = false;
        if (!this.model.isNew()) {
            let changeRequests = await this.options.project.fetchChangeRequests();
            _.each(changeRequests.models, (req) => {
                if (req.get('primeContractId') === this.model.id) {
                    this.hasChangeRequests = true;
                }
            })
        }

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.options.canViewChangeOrders = this.options.project.hasPermission('primeContractChangeOrders.canView');
        this.options.canAddChangeOrders = this.options.project.hasPermission('primeContractChangeOrders.isAdmin');
        this.options.canViewInvoices = this.options.project.hasPermission('receivableInvoices.canView');
        this.options.canAddInvoices = this.options.project.hasPermission('receivableInvoices.isAdmin');
        this.options.canEdit = this.options.project.hasPermission('primeContracts.canEdit');
        this.options.canUploadAttachments = this.options.canEdit;
        this.options.canEditLineItems = this.options.project.hasPermission('primeContracts.canEditLineItems');
        this.options.isAdmin = this.options.project.hasPermission('primeContracts.isAdmin');
        this.options.canDelete = this.options.isAdmin;
        this.options.canEditStatus = this.options.isAdmin;

        this.options.disabledStatuses = null;
        let fnGetGreaterStatuses = (statusId) => {
                return _.filter(PJQ.constants.commitments.commitmentStatus, (st) => {
                    return st < statusId;
                });
            },
            status = this.model.get('statusId');
        if (status !== PJQ.constants.primeContracts.primeContractStatus.TERMINATED) {
            this.options.canAddChangeOrders = PJQ.app.session.project.hasPermission('primeContractChangeOrders.isAdmin') && (status === PJQ.constants.primeContracts.primeContractStatus.COMPLETE || status === PJQ.constants.primeContracts.primeContractStatus.APPROVED);
            this.options.canAddInvoices = PJQ.app.session.project.hasPermission('receivableInvoices.isAdmin') && (status === PJQ.constants.primeContracts.primeContractStatus.COMPLETE || status === PJQ.constants.primeContracts.primeContractStatus.APPROVED);
        } else {
            this.options.canAddChangeOrders = false;
            this.options.canAddInvoices = false;
        }

        if (this.model.isNew()) {
            this.options.canEdit = true;
            this.options.canUploadAttachments = true;
            this.options.canEditLineItems = true;
        } else if (status === PJQ.constants.primeContracts.primeContractStatus.TERMINATED
            || status === PJQ.constants.primeContracts.primeContractStatus.COMPLETE
            || status === PJQ.constants.primeContracts.primeContractStatus.APPROVED) {
            this.options.canEdit = PJQ.app.session.project.hasPermission('primeContracts.canEdit');
            this.options.canUploadAttachments = this.options.isAdmin;
            this.options.canEditLineItems = false;
            this.options.canDelete = false;
        } else if (status === PJQ.constants.primeContracts.primeContractStatus.OUT_FOR_BID
            || status === PJQ.constants.primeContracts.primeContractStatus.OUT_FOR_SIGNATURE) {
            this.options.canEdit = this.options.isAdmin;
            this.options.canUploadAttachments = true;
            this.options.canEditLineItems = this.options.isAdmin;
        } else {
            this.options.canEdit = PJQ.app.session.project.hasPermission('primeContracts.canEdit');
            this.options.canUploadAttachments = true;
            this.options.canEditLineItems = PJQ.app.session.project.hasPermission('primeContracts.canEditLineItems');
        }

        if (this.model.invoices.models.length > 0 || this.model.changeRequests.models.length > 0) {
            this.options.disabledStatuses = fnGetGreaterStatuses(PJQ.constants.primeContracts.primeContractStatus.APPROVED);
            this.options.canEditLineItems = false;
        }

        if (!this.options.isAdmin && this.settings.get('isMarkupAdmin') === true) {
            this.options.canEditLineItems = false;
        }

        if (this.erpIntegration != null) {
            let syncStatus = this.model.erpSyncStatus();
            if (syncStatus === PJQ.constants.integrations.erp.syncStatuses.REVIEWING
                || syncStatus === PJQ.constants.integrations.erp.syncStatuses.APPROVED
                || syncStatus === PJQ.constants.integrations.erp.syncStatuses.SYNCED
            ) {
                this.options.canEditLineItems = false;
                this.options.canDelete = false;
            }
        }
    },
    renderData: function () {
        return {
            model: this.model,
            erpIntegration: this.erpIntegration,
            customFields: this.customFields,
            canViewChangeOrders: this.options.canViewChangeOrders,
            canAddChangeOrders: this.options.canAddChangeOrders,
            canViewInvoices: this.options.canViewInvoices,
            canAddInvoices: this.options.canAddInvoices,
            canEdit: this.options.canEdit,
            canEditLineItems: this.options.canEditLineItems,
            canUploadAttachments: this.options.canUploadAttachments,
            uploadCustomFields: this.uploadCustomFields,
            canDelete: this.options.canDelete,
            isAdmin: this.options.isAdmin,
            isFetched: this.isFetched,
            activeView: this.options.activeView,
            views: this.views,
            terms: this.terms,
            settings: this.settings,
            invoiceSettings: this.invoiceSettings,
            checkFieldVisible: _.bind(this.checkFieldVisible, this),
            checkFieldRequired: _.bind(this.checkFieldRequired, this),
            hasChangeRequests: this.hasChangeRequests,
            hasPendingInvoice: this.model && this.model.invoices.models.length > 0 && null != _.find(this.model.invoices.models, (invoice) => {
                return invoice.get('statusId') !== PJQ.constants.invoicing.receivableInvoiceStatus.APPROVED
                    && invoice.get('statusId') !== PJQ.constants.invoicing.receivableInvoiceStatus.COMPLETE;
            })
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.activateView(this.options.activeView);

        this.stopListening(this.model.markupItems);
        this.listenTo(this.model.markupItems, 'update', (markup) => {
            if (markup && markup.get('delete') && (markup.lineItem || markup.get('lineItemId'))) {
                let lineItem = markup.lineItem ?? this.model.lineItems.findWhere({appliedMarkupId: markup.id});

                if (lineItem) {
                    if (lineItem.get('id') > 0) {
                        lineItem.set('delete', true);
                    } else {
                        this.model.lineItems.remove(lineItem);
                    }
                }
            }

            this.updateCounts();
            this.lineItemsView.render();
        });

        this.stopListening(this.model);
        this.listenTo(this.model, 'change:statusId', () => {
            this.renderERP();
        });
        this.stopListening(this.model.lineItems);
        this.listenTo(this.model.lineItems, 'update', () => {
            this.renderERP();
        });
        this.renderERP();

        this.renderGeneral();
        this.renderLineItems();

        if (!this.model.isNew()) {
            if (this.options.canViewChangeOrders) {
                this.renderChangeOrders();
            }
            if (this.options.canViewInvoices) {
                this.renderInvoices();
                this.renderPayments();
            }
        }

        this.renderMarkups();

        this.updateCounts();
    },
    updateCounts: function () {
        this.$('.count-line-items').text(_.size(_.filter(this.model.lineItems.models, (item) => {
            return !item.get('delete');
        })));
        this.$('.count-change-orders').text(_.size(this.model.changeOrders.models));
        this.$('.count-invoices').text(_.size(this.model.invoices.models));
        this.$('.count-payments').text(_.size(this.model.payments.models));
        this.$('.count-markups').text(_.size(_.filter(this.model.markupItems.models, function (item) {
            return !item.get('delete');
        })));
    },
    views: {
        GENERAL: 'PC_General',
        LINEITEMS: 'PC_LineItems',
        CHANGEORDERS: 'PC_ChangeOrders',
        INVOICES: 'PC_Invoices',
        PAYMENTS: 'PC_Payments',
        MARKUPS: 'PC_Markups'
    },
    activeViewChanged: function (e) {
        let view = e.target.hash ? e.target.hash.replace('#', '') : null;
        this.activateView(view);
    },
    activateView: function (view) {
        if (view == null) {
            view = this.views.GENERAL;
        }

        this.$('.nav-link[href="#' + view + '"]').tab('show');
        this.options.activeView = view;

        if (view === this.views.LINEITEMS) {
            // this.lineItemsView.adjustColumns();
        }
    },
    renderMarkups: function () {
        if (!this.options.isAdmin) {
            return;
        }

        let syncStatus = this.model.erpSyncStatus();
        this.markupsView = new PJQ.financialMarkups.views.FinancialMarkupsList({
            el: this.$('.pc-markups'),
            collection: this.model.markupItems,
            canEdit: !this.hasChangeRequests && this.options.canEdit,
            autoVoid: (this.model.get("statusId") === PJQ.constants.primeContracts.primeContractStatus.APPROVED
                || this.model.get("statusId") === PJQ.constants.primeContracts.primeContractStatus.COMPLETE
                || syncStatus === PJQ.constants.integrations.erp.syncStatuses.SYNCED),
            canVoid: true,
            defaultToAppliedMarkups: this.settings.get('defaultToAppliedMarkups'),
        });
    },
    renderERP: function () {
        let $erp = this.$('.erp-sync');
        if (!this.options.isAdmin || this.erpIntegration == null || !this.options.project.isERPSynced()
            || false === this.erpIntegration.getSetting(PJQ.constants.integrations.settings.SYNC_PRIME_CONTRACTS)) {
            $erp.remove();
            return;
        }

        let canPush = true,
            disablePushReason = "";
        if (_.size(this.model.lineItems.models) === 0
            || (this.model.get('statusId') !== PJQ.constants.primeContracts.primeContractStatus.APPROVED && this.model.get('statusId') !== PJQ.constants.primeContracts.primeContractStatus.COMPLETE)) {
            canPush = false;
            disablePushReason = "Contract must be approved and have line items";
        }

        PJQ.helpers.erp.renderERPButtons(this.$('.erp-sync'), {
            status: this.model.erpSyncStatus(),
            pushSupported: this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_PRIME_CONTRACTS),
            canPush: canPush,
            canPushChanges: false,
            disablePushReason: disablePushReason,
            unlinkSupported: this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.UNLINK_PRIME_CONTRACTS)
        });
    },
    pushERP: function (callback) {
        if (!this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_PRIME_CONTRACTS)) {
            return;
        }

        this.save((success) => {
            if (success) {
                this.erpIntegration.pushPrimeContract(this.model, () => {
                    PJQ.notifications.notify.successNotify({
                        message: 'Contract pushed to ERP'
                    });

                    if (typeof this.options.onSave === 'function') {
                        this.options.onSave(this.model);
                    }

                    if (typeof callback === 'function') {
                        callback();
                    } else {
                        this.render();
                    }
                });
            }
        });
    },
    undoPushERP: function () {
        if (this.model.erpSyncStatus() === PJQ.constants.integrations.erp.syncStatuses.REVIEWING) {
            this.erpIntegration.undoPush(this.model, () => {
                PJQ.notifications.notify.successNotify({
                    message: 'Contract removed from ERP approval'
                });

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }

                this.render();
            });
        }
    },
    unlinkERP: function () {
        new PJQ.views.modals.YesNo({
            header: "Unlink from ERP",
            body: "Are you sure you want to unlink this Contract from your ERP system?  This will also unlink all Change Orders and Invoices associated with it.",
            onYes: () => {
                let loader = new PJQ.Loader(this.$('.modal-content'));
                this.erpIntegration.unlinkPrimeContract(this.model, _.bind(function (success) {
                    if (success) {
                        loader.remove();
                        PJQ.notifications.notify.successNotify({
                            message: 'Contract unlinked from ERP'
                        });

                        if (typeof this.options.onSave === 'function') {
                            this.options.onSave(this.model);
                        }

                        this.render();
                    }
                }, this));
            }
        });
    },
    renderGeneral: function () {
        new PJQ.Binder(this.$el, this.model, {
            canEdit: !this.options.canEdit ? false : null,
            useDecimalPercentFields: true,
            watchElements: [
                'input',
                'textarea'
            ]
        });

        this.clientPicker = new PJQ.views.contacts.ContactsSelectInput({
            el: this.$('.contract-client'),
            context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
            hideUsers: true,
            selectedContact: this.model.client,
            isSingleChoice: true,
            canViewContacts: this.options.project.hasPermission('projectContacts.canView'),
            canEdit: this.options.canEdit,
            onChange: _.bind(function (selectedContact) {
                this.model.client = selectedContact;
                this.model.set('clientId', selectedContact ? selectedContact.id : 0);
            }, this)
        });

        new PJQ.views.contacts.ContactsSelectInput({
            el: this.$('.contract-architect'),
            context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
            hideUsers: true,
            selectedContact: this.model.architect,
            isSingleChoice: true,
            canViewContacts: this.options.project.hasPermission('projectContacts.canView'),
            canEdit: this.options.canEdit,
            onChange: _.bind(function (selectedContact) {
                this.model.architect = selectedContact;
                this.model.set('architectId', selectedContact ? selectedContact.id : 0);
            }, this)
        });

        let choices = _.map(PJQ.constants.primeContracts.primeContractStatus, (st) => {
            return {
                id: st,
                name: PJQ.constants.primeContracts.primeContractStatusNames[st],
                disabled: this.options.disabledStatuses != null && this.options.disabledStatuses.indexOf(st) > -1
            }
        });
        this.statusPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-status'),
            choices: choices,
            defaultValue: this.model.get('statusId') != null ? this.model.get('statusId') : 2,
            canEdit: this.options.canEditStatus,
            isMultiple: false,
            isIntChoices: true,
            onChange: _.bind(function (newStatus) {
                let oldStatus = this.model.get('statusId');
                if (newStatus === oldStatus) {
                    return;
                }

                this.model.set('statusId', newStatus);
                if (!this.model.isNew()) {
                    this.save((success) => {
                        if (success) {
                            PJQ.notifications.notify.successNotify({
                                message: 'Contract saved successfully'
                            });
                        } else {
                            this.model.set('statusId', oldStatus);
                            this.statusPicker.setValue(oldStatus);
                        }
                    });
                } else {
                    this.render();
                }
            }, this)
        });

        let defaultTerm = _.find(this.terms.models, function (model) {
            return model.get('isDefault');
        }, this);
        if (this.model.isNew() && defaultTerm != null && defaultTerm.id > 0) {
            this.model.set('termsId', defaultTerm.id);
        }
        this.termsPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-terms'),
            isIntChoices: true,
            defaultValue: this.model.get('termsId'),
            canEdit: this.options.canEdit && this.options.isAdmin,
            onChange: _.bind(function (newTermsId) {
                this.model.set('termsId', newTermsId ? newTermsId : 0);
            }, this)
        });

        if (this.checkFieldVisible('attachments')) {
            this.fileUploader = new PJQ.views.files.FileUploaderGrid({
                el: this.$('.contract-file-uploader'),
                collection: this.model.attachments,
                canUpload: this.options.canUploadAttachments,
                useApiV2: true,
                canView: false,
                canDelete: this.options.isAdmin,
                previewImageDimension: 150,
                onSuccess: _.bind(function (file) {
                    this.model.isDirty = true;
                }, this),
                onDelete: _.bind(function (attachment, callback) {
                    if (attachment.get('id') > 0) {
                        attachment.set('delete', true);
                    } else {
                        attachment.destroy();
                    }

                    this.model.isDirty = true;
                    callback();
                }, this)
            })
        }

        if (this.checkFieldVisible('signedDocumentAttachments')) {
            this.signedDocumentUploader = new PJQ.views.files.FileUploaderGrid({
                el: this.$('.signed-file-uploader'),
                collection: this.model.signedDocumentAttachments,
                canUpload: this.options.canUploadAttachments,
                useApiV2: true,
                canView: false,
                canDelete: this.options.isAdmin,
                previewImageDimension: 150,
                onSuccess: _.bind(function (file) {
                    this.model.isDirty = true;
                }, this),
                onDelete: _.bind(function (attachment, callback) {
                    if (attachment.get('id') > 0) {
                        attachment.set('delete', true);
                    } else {
                        attachment.destroy();
                    }

                    this.model.isDirty = true;
                    callback();
                }, this)
            });
        }

        if (this.checkFieldVisible('executedDocumentAttachments')) {
            this.executedDocumentUploader = new PJQ.views.files.FileUploaderGrid({
                el: this.$('.executed-file-uploader'),
                collection: this.model.executedDocumentAttachments,
                canUpload: this.options.canUploadAttachments,
                useApiV2: true,
                canView: false,
                canDelete: this.options.isAdmin,
                previewImageDimension: 150,
                onSuccess: _.bind(function (file) {
                    this.model.isDirty = true;
                }, this),
                onDelete: _.bind(function (attachment, callback) {
                    if (attachment.get('id') > 0) {
                        attachment.set('delete', true);
                    } else {
                        attachment.destroy();
                    }

                    this.model.isDirty = true;
                    callback();
                }, this)
            });
        }

        // Render date pickers in separate function because there are so many
        this.renderDatePickers();

        if (this.customFields && _.size(this.customFields.models) > 0) {
            this.customFieldsForm = new PJQ.views.customFields.CustomFieldsForm({
                el: this.$('.prime-contract-custom-fields'),
                collection: this.customFields,
                fieldValues: this.model.get('customFieldValues'),
                isEdit: this.options.canEdit,
                isAdmin: this.options.isAdmin,
            });
        }
        if (_.size(this.uploadCustomFields) > 0) {
            this.renderUploadCustomFields();
        }
    },
    renderUploadCustomFields: function () {
        this.customFieldUploaders = [];
        _.each(this.uploadCustomFields, function (field) {
            let type = 'cf-' + field.id,
                $upload = this.$("." + type + '-file-uploader'),
                canUpload = this.options.canUploadAttachments && (!field.get('isAdminEdit') || this.options.isAdmin),
                customFieldAttachments = _.filter(this.model.customFieldAttachments.models, function (attachment) {
                    return attachment.get('type') === type;
                });

            if (_.size(customFieldAttachments) === 0 && !canUpload) {
                $upload.closest('.upload-outer').hide();
                return;
            }

            let attachmentsCollection = new PJQ.collections.commitments.CommitmentAttachments(customFieldAttachments);
            let uploader = new PJQ.views.files.FileUploaderGrid({
                el: $upload,
                collection: attachmentsCollection,
                canUpload: canUpload,
                useApiV2: true,
                canView: false,
                useBlob: true,
                canDelete: this.options.isAdmin,
                previewImageDimension: 150,
                onSuccess: _.bind(function (file) {
                    this.model.isDirty = true;
                    uploader.clearError();

                    let newAttachment = _.find(attachmentsCollection.models, function (attachment) {
                        return attachment.get('uploadId') === file.uploadId;
                    });

                    if (newAttachment != null) {
                        newAttachment.set('type', type);
                        this.model.customFieldAttachments.add(newAttachment);
                    }
                }, this),
                onDelete: _.bind(function (attachment, callback) {
                    if (attachment.get('id') > 0) {
                        let customFieldAttachment = this.model.customFieldAttachments.findWhere({id: attachment.get('id')});

                        attachment.set('delete', true);
                        if (customFieldAttachment != null) {
                            customFieldAttachment.set('delete', true);
                        }
                    } else {
                        let customFieldAttachment = this.model.customFieldAttachments.findWhere({uploadId: attachment.get('uploadId')});

                        attachment.destroy();
                        if (customFieldAttachment != null) {
                            this.model.customFieldAttachments.remove(customFieldAttachment);
                        }
                    }

                    this.model.isDirty = true;
                    callback();
                }, this)
            });
            this.customFieldUploaders.push(uploader);
        }, this);
    },
    renderDatePickers: function () {
        // These are in order as they are displayed on the page
        new PJQ.inputs.Datepicker({
            el: this.$('.contract-start'),
            canEdit: this.options.canEdit,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('startOn')
            },
            onChange: _.bind(function (newDate) {
                let currentDueDate = this.model.get('startOn');
                if (currentDueDate == null || PJQ.helpers.dateHelpers.getDateDaysDiff(newDate, new Date(currentDueDate)) !== 0) {
                    this.model.set('startOn', newDate);
                }
            }, this)
        });

        new PJQ.inputs.Datepicker({
            el: this.$('.estimated-completion'),
            canEdit: this.options.canEdit,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('estimatedCompleteOn')
            },
            onChange: _.bind(function (newDate) {
                let currentDueDate = this.model.get('estimatedCompleteOn');
                if (currentDueDate == null || PJQ.helpers.dateHelpers.getDateDaysDiff(newDate, new Date(currentDueDate)) !== 0) {
                    this.model.set('estimatedCompleteOn', newDate);
                }
            }, this)
        });

        new PJQ.inputs.Datepicker({
            el: this.$('.substantial-completion'),
            canEdit: this.options.canEdit,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('substantialCompleteOn')
            },
            onChange: _.bind(function (newDate) {
                let currentDueDate = this.model.get('substantialCompleteOn');
                if (currentDueDate == null || PJQ.helpers.dateHelpers.getDateDaysDiff(newDate, new Date(currentDueDate)) !== 0) {
                    this.model.set('substantialCompleteOn', newDate);
                }
            }, this)
        });

        new PJQ.inputs.Datepicker({
            el: this.$('.actual-completion'),
            canEdit: this.options.canEdit,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('actualCompleteOn')
            },
            onChange: _.bind(function (newDate) {
                let currentDueDate = this.model.get('actualCompleteOn');
                if (currentDueDate == null || PJQ.helpers.dateHelpers.getDateDaysDiff(newDate, new Date(currentDueDate)) !== 0) {
                    this.model.set('actualCompleteOn', newDate);
                }
            }, this)
        });

        new PJQ.inputs.Datepicker({
            el: this.$('.contract-date'),
            canEdit: this.options.canEdit,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('contractOn')
            },
            onChange: _.bind(function (newDate) {
                let currentDueDate = this.model.get('contractOn');
                if (currentDueDate == null || PJQ.helpers.dateHelpers.getDateDaysDiff(newDate, new Date(currentDueDate)) !== 0) {
                    this.model.set('contractOn', newDate);
                }
            }, this)
        });

        new PJQ.inputs.Datepicker({
            el: this.$('.signed-contract-date'),
            canEdit: this.options.canEdit,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('signedContractOn')
            },
            onChange: _.bind(function (newDate) {
                let currentDueDate = this.model.get('signedContractOn');
                if (currentDueDate == null || PJQ.helpers.dateHelpers.getDateDaysDiff(newDate, new Date(currentDueDate)) !== 0) {
                    this.model.set('signedContractOn', newDate);
                }
            }, this)
        });

        new PJQ.inputs.Datepicker({
            el: this.$('.letter-of-intent'),
            canEdit: this.options.canEdit,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('letterOfIntentOn')
            },
            onChange: _.bind(function (newDate) {
                let currentDueDate = this.model.get('letterOfIntentOn');
                if (currentDueDate == null || PJQ.helpers.dateHelpers.getDateDaysDiff(newDate, new Date(currentDueDate)) !== 0) {
                    this.model.set('letterOfIntentOn', newDate);
                }
            }, this)
        });

        new PJQ.inputs.Datepicker({
            el: this.$('.approval-letter'),
            canEdit: this.options.canEdit,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('approvalLetterOn')
            },
            onChange: _.bind(function (newDate) {
                let currentDueDate = this.model.get('approvalLetterOn');
                if (currentDueDate == null || PJQ.helpers.dateHelpers.getDateDaysDiff(newDate, new Date(currentDueDate)) !== 0) {
                    this.model.set('approvalLetterOn', newDate);
                }
            }, this)
        });

        new PJQ.inputs.Datepicker({
            el: this.$('.contract-issued-on'),
            canEdit: this.options.canEdit,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('issuedOn')
            },
            onChange: _.bind(function (newDate) {
                let currentDueDate = this.model.get('issuedOn');
                if (currentDueDate == null || PJQ.helpers.dateHelpers.getDateDaysDiff(newDate, new Date(currentDueDate)) !== 0) {
                    this.model.set('issuedOn', newDate);
                }
            }, this)
        });

        new PJQ.inputs.Datepicker({
            el: this.$('.execution-date'),
            canEdit: this.options.canEdit,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('executedOn')
            },
            onChange: _.bind(function (newDate) {
                let currentDueDate = this.model.get('executedOn');
                if (currentDueDate == null || PJQ.helpers.dateHelpers.getDateDaysDiff(newDate, new Date(currentDueDate)) !== 0) {
                    this.model.set('executedOn', newDate);
                }
            }, this)
        });

        new PJQ.inputs.Datepicker({
            el: this.$('.contract-returned'),
            canEdit: this.options.canEdit,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('returnedOn')
            },
            onChange: _.bind(function (newDate) {
                let currentDueDate = this.model.get('returnedOn');
                if (currentDueDate == null || PJQ.helpers.dateHelpers.getDateDaysDiff(newDate, new Date(currentDueDate)) !== 0) {
                    this.model.set('returnedOn', newDate);
                }
            }, this)
        });

        new PJQ.inputs.Datepicker({
            el: this.$('.contract-termination'),
            canEdit: this.options.canEdit,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('contractTerminatedOn')
            },
            onChange: _.bind(function (newDate) {
                let currentDueDate = this.model.get('contractTerminatedOn');
                if (currentDueDate == null || PJQ.helpers.dateHelpers.getDateDaysDiff(newDate, new Date(currentDueDate)) !== 0) {
                    this.model.set('contractTerminatedOn', newDate);
                }
            }, this)
        });
    },
    formatPercent: function (e) {
        $(e.currentTarget).val(PJQ.helpers.formatHelpers.formatPercent($(e.currentTarget).val()));
    },
    numbersOnly: function (e) {
        return PJQ.helpers.inputHelpers.numbersOnly(e, true, true);
    },
    checkFieldVisible: function (fieldName) {
        if (this.coreFieldSettings) {
            let fieldSettings = this.coreFieldSettings.findWhere({fieldName: fieldName});
            if (fieldSettings != null) {
                return fieldSettings.get('isVisible');
            }
        }
        return true;
    },
    checkFieldRequired: function (fieldName) {
        if (this.coreFieldSettings) {
            let fieldSettings = this.coreFieldSettings.findWhere({fieldName: fieldName});
            if (fieldSettings != null) {
                return fieldSettings.get('isRequired');
            }
        }
        return false;
    },
    viewHistory: async function () {
        let historyItems = [{
            date: this.model.get('createdOn'),
            person: this.model.get('createdBy'),
            action: 'Contract Created'
        }];

        let history = new PJQ.collections.primeContracts.History({}, {
            primeContractId: this.model.id
        });
        new PJQ.views.history.HistoryTimelineModal({
            collection: history,
            subTitle: 'Contract #' + this.model.get('number'),
            items: historyItems
        });
    },
    exportPrimeContract: function (withMarkup = false) {
        let params = [];
        if (withMarkup === true) {
            params.push({
                parameter: 'withMarkup',
                value: true
            });
        }

        let callback = () => {
            PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'primecontracts',
                    value: this.model.get('id')
                },
                {
                    endpoint: 'export',
                }
            ], params), {isAPIv2: true});
        };
        if (this.options.canEdit && this.model.hasChanged()) {
            this.save(callback);
        } else {
            callback();
        }
    },
    exportPrimeContractWithMarkup: function () {
        this.exportPrimeContract(true);
    },
    renderLineItems: function () {
        if (this.lineItemsView) {
            this.lineItemsView.remove();
        }

        this.lineItemsView = new PJQ.views.budget.LineItemsView({
            el: this.$('.line-items'),
            model: this.model,
            contract: this.model,
            collection: this.model.lineItems,
            lineItemModel: PJQ.models.primeContracts.LineItem,
            canEdit: this.options.canEditLineItems,
            canDelete: this.options.canEditLineItems,
            accountingMethod: this.model.get('accountingMethod'),
            canChangeAccountingMethod: this.options.canEditLineItems,
            canImportBudget: true,
            financialMarkups: this.model.markupItems,
            showMarkup: this.options.isAdmin || this.settings.get('isMarkupAdmin') !== true,
            enableTax: true,
            billedToDate: this.options.canViewInvoices && this.model.invoices != null ? () => {
                let res = 0;
                _.each(this.model.invoices.models, function (invoice) {
                    if (invoice.get('statusId') === PJQ.constants.invoicing.receivableInvoiceStatus.APPROVED
                        || invoice.get('statusId') === PJQ.constants.invoicing.receivableInvoiceStatus.COMPLETE) {
                        res += invoice.getGrandTotal();
                    }
                });
                return res;
            } : null,
            showBilling: this.model.get('statusId') === PJQ.constants.primeContracts.primeContractStatus.APPROVED || this.model.get('statusId') === PJQ.constants.primeContracts.primeContractStatus.COMPLETE,
            approvedChanges: this.model.get('approvedChanges'),
            onApprovedChangesClicked: () => {
                this.activateView(this.views.CHANGEORDERS);
            },
            onBilledToDateClicked: () => {
                this.activateView(this.views.INVOICES);
            },
            showSubTotal: true,
            showGrandTotal: true,
            onAccountingMethodChanged: _.bind(function (value) {
                this.model.set('accountingMethod', value);
            }, this),
            onLineItemChange: _.bind(function () {
                this.model.isDirty = true;
            }, this),
            onLineItemAdd: _.bind(function () {
                this.model.isDirty = true;
                this.updateCounts();
            }, this),
            onLineItemDelete: _.bind(function () {
                this.model.isDirty = true;
                this.updateCounts();
            }, this)
        });
    },
    renderChangeOrders: function () {
        if (this.model.isNew()) {
            return;
        }

        this.changeOrderTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.change-orders'),
            data: this.model.changeOrders.models,
            isHideSearch: true,
            language: {
                emptyTable: this.options.canAddChangeOrders ? 'Click "New Change Order" to create a Contract Change Order' : 'No change orders have been created'
            },
            paging: false,
            contextMenuOptions: {
                actions: [
                    {
                        name: 'View',
                        onClick: _.bind(function (row) {
                            this.viewChangeOrder(row.data());
                        }, this),
                        isShown: _.bind(function (row) {
                            return this.options.canViewChangeOrders;
                        }, this)
                    }
                ]
            },
            order: [1, 'asc'],
            hasFooter: true,
            columns: [
                {
                    "columnData": "",
                    "data": null,
                    "title": "",
                    "width": "40px",
                    "orderable": false,
                    "searchable": false,
                    "defaultContent": '',
                    "render": function (data, type, row) {
                        let exObj = row.get('externalObject');
                        if (exObj == null) {
                            return '';
                        }

                        return PJQ.helpers.erp.getERPBadge(exObj.status, exObj);
                    }
                }, {
                    "data": "attributes.number",
                    "title": "Number",
                    "render": (data, type, row) => {
                        if (type === 'sort') {
                            return row.id;
                        }

                        return '<a href="javascript:void(0)" class="btn-view-change-order">' + data + '</a>'
                    }
                }, {
                    "data": "attributes.description",
                    "title": "Description",
                }, {
                    "columnData": "createdOn",
                    "data": "attributes.createdOn",
                    "title": 'Created',
                    "width": '120px',
                    "render": (data, type, row) => {
                        return PJQ.helpers.dateHelpers.getDateString(new Date(row.get('createdOn')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                    }
                }, {
                    "data": "attributes.invoicedDate",
                    "title": 'Invoiced Date',
                    "width": '120px',
                    "render": (data, type, row) => {
                        if (_.size(row.get('invoicedDate')) === 0) {
                            return '';
                        }

                        return PJQ.helpers.dateHelpers.getDateString(new Date(row.get('invoicedDate')), PJQ.helpers.dateHelpers.dateFormats.DATE);
                    }
                }, {
                    "data": "attributes.dueDate",
                    "title": 'Due Date',
                    "width": '120px',
                    "render": (data, type, row) => {
                        if (_.size(row.get('dueDate')) === 0) {
                            return '';
                        }

                        return PJQ.helpers.dateHelpers.getDateString(new Date(row.get('invoicedDate')), PJQ.helpers.dateHelpers.dateFormats.DATE);
                    }
                }, {
                    "data": "attributes.statusId",
                    "title": "Status",
                    "width": "150px",
                    "render": (data, type, row) => {
                        return PJQ.constants.commitments.changeOrderStatusNames[row.get('statusId')];
                    }
                }, {
                    "data": "attributes.amount",
                    "title": "Grand Total",
                    "width": "120px",
                    "render": (data, type, row) => {
                        return PJQ.helpers.formatHelpers.formatCurrency(row.getGrandTotal());
                    },
                    "renderFooter": function (data) {
                        let amt = 0;
                        _.each(data, function (changeOrder) {
                            amt += changeOrder.getGrandTotal();
                        });
                        return PJQ.helpers.formatHelpers.formatCurrency(amt);
                    }
                }, {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": "80px",
                    "render": (data, type, row) => {
                        let html = '<div class="text-align-right show-on-row-hover" style="width: 80px;">'
                        if (this.options.canViewInvoices) {
                            html += '<button type="button" class="btn btn-info btn-view-change-order ht-30p wd-35p ml-1 fs-14"><span class="fal fa-pencil"></span></button>'
                        }
                        return html + '</div>';
                    }
                }],
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>',
            onRowDoubleClick: _.bind(function (row) {
                this.viewChangeOrder(row.data());
            }, this)
        });
    },
    newChangeOrder: function () {
        this.viewChangeOrder();
    },
    viewChangeOrderClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.changeOrderTable.getRow(target.closest('tr'));
        this.viewChangeOrder(row.data());
    },
    viewChangeOrder: function (changeOrder) {
        this.removeModal();
        new PJQ.views.primeContracts.ChangeOrderEditModal({
            primeContract: this.model,
            model: changeOrder,
            onSave: _.bind(function (changeOrder, isNew) {
                if (isNew) {
                    this.model.changeOrders.add(changeOrder);
                    this.changeOrderTable.addRow(changeOrder);
                } else {
                    this.changeOrderTable.refresh();
                }
                if (typeof this.options.onChangeOrderAdd === 'function' && isNew) {
                    this.options.onChangeOrderAdd(changeOrder);
                }
                this.updateCounts();

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
            }, this),
            onDelete: _.bind(function () {
                let row = this.changeOrderTable.getRow(changeOrder.cid);
                this.model.changeOrders.remove(changeOrder);
                this.changeOrderTable.removeRow(row);
                this.updateCounts()

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
            }, this)
        });
    },
    newInvoice: function () {
        this.viewInvoice();
    },
    viewInvoiceClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.invoicesDataTable.getRow(target.closest('tr'));
        this.viewInvoice(row.data());
    },
    viewInvoice: function (invoice) {
        this.removeModal();
        new PJQ.views.invoicing.EditReceivableInvoiceModal({
            primeContract: this.model,
            model: invoice,
            onDelete: _.bind(function () {
                this.updateCounts();

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
            }, this),
            onSave: _.bind(function (invoice, isNew) {
                if (isNew) {
                    this.model.invoices.add(invoice);
                    this.invoicesDataTable.addRow(invoice);

                    if (typeof this.options.onInvoiceAdd === 'function') {
                        this.options.onInvoiceAdd(invoice);
                    }
                }
                this.updateCounts();

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
            }, this)
        });
    },
    viewPaymentClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.paymentsDataTable.getRow(target.closest('tr'));
        this.viewPayment(row.data());
    },
    viewPayment: function (payment) {
        this.removeModal();
        new PJQ.views.invoicing.InvoicePaymentModal({
            model: payment,
            onSave: _.bind(function (payment, isNew) {
                if (isNew) {
                    let invoice = this.model.invoices.get(payment.get('invoiceId'));
                    if (invoice != null) {
                        invoice.payments.add(payment);
                    }

                    this.paymentsDataTable.addRow(invoice);
                }
                this.updateCounts();

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
            }, this),
            onDelete: _.bind(function () {
                this.updateCounts();

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
            }, this)
        });
    },
    deletePrimeContract: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Delete",
            body: "Are you sure you want to delete this contract?  All associated change orders and invoices will also be deleted.",
            onDelete: _.bind(function () {
                this.model.destroy({
                    success: _.bind(function () {
                        PJQ.notifications.notify.successNotify({
                            message: 'Contract deleted successfully'
                        });

                        if (typeof this.options.onDelete === 'function')
                            this.options.onDelete();

                        this.removeModal();

                        if (typeof this.options.onSave === 'function') {
                            this.options.onSave(this.model);
                        }
                    }, this)
                });
            }, this)
        });
    },
    renderInvoices: function () {
        if (this.model.isNew()) {
            return;
        }

        this.invoicesDataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.pc-invoices'),
            data: this.model.invoices.models,
            isHideSearch: true,
            language: {
                emptyTable: 'No Invoices have been created yet',
                zeroRecords: "No Invoices matched the search criteria"
            },
            paging: false,
            order: [1, 'asc'],
            hasFooter: true,
            columns: [
                {
                    "columnData": "",
                    "data": null,
                    "title": "",
                    "width": "40px",
                    "orderable": false,
                    "searchable": false,
                    "defaultContent": '',
                    "render": function (data, type, row) {
                        let exObj = row.get('externalObject');
                        if (exObj == null) {
                            return '';
                        }

                        return PJQ.helpers.erp.getERPBadge(exObj.status, exObj);
                    }
                }, {
                    "title": "#",
                    "data": "attributes.number",
                    "render": (data, type, row) => {
                        if (type === 'sort') {
                            return row.id;
                        }

                        return '<a href="javascript:void(0)" class="btn-view-invoice">' + data + '</a>'
                    }
                },
                {
                    "title": 'Billing Period',
                    "data": "",
                    "width": '200px',
                    "render": (data, type, row) => {
                        let periodStart = PJQ.helpers.dateHelpers.getDateString(new Date(row.get('startDate')), PJQ.helpers.dateHelpers.dateFormats.DATE, true),
                            periodEnd = PJQ.helpers.dateHelpers.getDateString(new Date(row.get('endDate')), PJQ.helpers.dateHelpers.dateFormats.DATE, true);

                        return (periodStart) + ' - ' + (periodEnd);
                    }
                },
                {
                    "title": 'Due Date',
                    "data": "",
                    "width": '120px',
                    "render": (data, type, row) => {
                        return PJQ.helpers.dateHelpers.getDateString(new Date(row.get('billingDate')), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                    }
                },
                {
                    "data": "",
                    "title": "Status",
                    "width": "150px",
                    "render": (data, type, row) => {
                        return PJQ.constants.invoicing.receivableInvoiceStatusNames[row.get('statusId')]
                    }
                },
                {
                    "data": "attributes.amount",
                    "title": "Retainage",
                    "width": "120px",
                    "render": (data, type, row) => {
                        return PJQ.helpers.formatHelpers.formatCurrency(row.getRetainage());
                    },
                    "renderFooter": function (data) {
                        let amt = 0;
                        _.each(data, function (invoice) {
                            amt += invoice.getRetainage();
                        });
                        return PJQ.helpers.formatHelpers.formatCurrency(amt);
                    }
                },
                {
                    "data": "attributes.amount",
                    "title": "Grand Total",
                    "width": "120px",
                    "render": (data, type, row) => {
                        return PJQ.helpers.formatHelpers.formatCurrency(row.getGrandTotal());
                    },
                    "renderFooter": function (data) {
                        let amt = 0;
                        _.each(data, function (invoice) {
                            amt += invoice.getGrandTotal();
                        });
                        return PJQ.helpers.formatHelpers.formatCurrency(amt);
                    }
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": "40px",
                    "render": (data, type, row) => {
                        let html = '<div class="text-align-right show-on-row-hover">'
                        if (this.options.canViewInvoices) {
                            html += '<button type="button" class="btn btn-info btn-view-invoice ht-30p wd-35p ml-1 fs-14"><span class="fal fa-pencil"></span></button>'
                        }
                        return html + '</div>';
                    }
                }],
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>',
            contextMenuOptions: {
                actions: [
                    {
                        name: 'View',
                        onClick: _.bind(function (row) {
                            this.viewInvoice(row.data());
                        }, this),
                        isShown: _.bind(function (row) {
                            return this.options.canViewInvoices;
                        }, this)
                    }
                ]
            },
            onRowDoubleClick: _.bind(function (row) {
                this.viewInvoice(row.data());
            }, this)
        });
    },
    renderPayments: function () {
        if (this.model.isNew() || !this.invoiceSettings.get('enablePayments')) {
            return;
        }

        this.paymentsDataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.pc-payments'),
            data: this.model.payments.models,
            isHideSearch: true,
            language: {
                emptyTable: 'No Payments have been created yet',
                zeroRecords: "No Payments matched the search criteria"
            },
            paging: false,
            order: [1, 'asc'],
            hasFooter: true,
            columns: [{
                "columnData": "",
                "data": null,
                "title": "",
                "width": "20px",
                "orderable": false,
                "searchable": false,
                "defaultContent": '',
                "render": function (data, type, row) {
                    let exObj = row.get('externalObject');
                    if (exObj == null) {
                        return '';
                    }

                    return PJQ.helpers.erp.getERPBadge(exObj.status, exObj);
                }
            },
                {
                    "title": "#",
                    "data": "attributes.number",
                    "render": _.bind(function (data, type, row) {
                        if (type === 'sort') {
                            return row.id;
                        }

                        return '<a href="javascript:void(0)" class="btn-view-payment">' + data + '</a>'
                    }, this)
                },
                {
                    "title": "Check #",
                    "data": "attributes.checkNumber"
                },
                {
                    "title": 'Received',
                    "data": "",
                    "render": _.bind(function (data, type, row) {
                        let dateReceived = row.get('dateReceived');
                        if (_.size(dateReceived) === 0) {
                            return '';
                        }

                        return PJQ.helpers.dateHelpers.getDateString(new Date(dateReceived), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                    }, this)
                },
                {
                    "title": "Payment Method",
                    "data": "attributes.paymentMethod",
                    "render": _.bind(function (data, type, row) {
                        return PJQ.constants.invoicing.paymentMethods.find(item => item.toLowerCase() === data.toLowerCase()) ?? '';
                    }, this)
                },
                {
                    "data": "attributes.amount",
                    "title": "Amount",
                    "render": (data, type, row) => {
                        return PJQ.helpers.formatHelpers.formatCurrency(row.get('amount'));
                    },
                    "renderFooter": function (data) {
                        let amt = 0;
                        _.each(data, function (payment) {
                            amt += payment.get('amount');
                        });
                        return PJQ.helpers.formatHelpers.formatCurrency(amt);
                    }
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": "80px",
                    "render": _.bind(function (data, type, row) {
                        let html = '<div class="text-align-right show-on-row-hover">'
                        if (this.options.canViewInvoices) {
                            html += '<button type="button" class="btn btn-info btn-view-payment ht-30p wd-35p ml-1 fs-14"><span class="fal fa-pencil"></span></button>'
                        }
                        return html + '</div>';
                    }, this)
                }],
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>',
            contextMenuOptions: {
                actions: [
                    {
                        name: 'View',
                        onClick: _.bind(function (row) {
                            this.viewPayment(row.data());
                        }, this),
                        isShown: _.bind(function (row) {
                            return this.options.canViewInvoices;
                        }, this)
                    }
                ]
            },
            onRowDoubleClick: _.bind(function (row) {
                this.viewPayment(row.data());
            }, this)
        });
    },
    validate: function () {
        if (!this.options.canEdit || this.model.isERPSynced()) {
            return true;
        }

        let isValid = true;
        if (!this.clientPicker.validate()) {
            isValid = false;
        }
        if (this.customFieldsForm != null && !this.customFieldsForm.validate()) {
            isValid = false;
        }

        if (this.checkFieldRequired('number')) {
            let $number = this.$('.prime-contract-number');
            PJQ.helpers.inputHelpers.setInputError($number, true);
            if (_.size(this.model.get('number')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($number, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('defaultWorkRetainagePercent')) {
            let $workRetainage = this.$('.default-work-retainage');
            PJQ.helpers.inputHelpers.setInputError($workRetainage, true);
            if (this.model.get('defaultWorkRetainagePercent') == null) {
                PJQ.helpers.inputHelpers.setInputError($workRetainage, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('defaultMaterialRetainagePercent')) {
            let $materialRetainage = this.$('.default-material-retainage');
            PJQ.helpers.inputHelpers.setInputError($materialRetainage, true);
            if (this.model.get('defaultMaterialRetainagePercent') == null) {
                PJQ.helpers.inputHelpers.setInputError($materialRetainage, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('termsId')) {
            let $terms = this.$('.select-terms');
            PJQ.helpers.inputHelpers.setInputError($terms, true);
            if (this.model.get('termsId') == null || this.model.get('termsId') === 0) {
                PJQ.helpers.inputHelpers.setInputError($terms, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('description')) {
            let $description = this.$('.contract-description');
            PJQ.helpers.inputHelpers.setInputError($description, true);
            if (_.size(this.model.get('description')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($description, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('startOn')) {
            let $startDate = this.$('.contract-start');
            PJQ.helpers.inputHelpers.setInputError($startDate, true);
            if (this.model.get('startOn') == null || this.model.get('startOn').length === 0) {
                PJQ.helpers.inputHelpers.setInputError($startDate, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('estimatedCompleteOn')) {
            let $estimatedCompletionDate = this.$('.estimated-completion');
            PJQ.helpers.inputHelpers.setInputError($estimatedCompletionDate, true);
            if (this.model.get('estimatedCompleteOn') == null || this.model.get('estimatedCompleteOn').length === 0) {
                PJQ.helpers.inputHelpers.setInputError($estimatedCompletionDate, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('substantialCompleteOn')) {
            let $substantialCompletionDate = this.$('.substantial-completion');
            PJQ.helpers.inputHelpers.setInputError($substantialCompletionDate, true);
            if (this.model.get('substantialCompleteOn') == null || this.model.get('substantialCompleteOn').length === 0) {
                PJQ.helpers.inputHelpers.setInputError($substantialCompletionDate, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('actualCompleteOn')) {
            let $actualCompletionDate = this.$('.actual-completion');
            PJQ.helpers.inputHelpers.setInputError($actualCompletionDate, true);
            if (this.model.get('actualCompleteOn') == null || this.model.get('actualCompleteOn').length === 0) {
                PJQ.helpers.inputHelpers.setInputError($actualCompletionDate, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('contractOn')) {
            let $contractDate = this.$('.contract-date');
            PJQ.helpers.inputHelpers.setInputError($contractDate, true);
            if (this.model.get('contractOn') == null || this.model.get('contractOn').length === 0) {
                PJQ.helpers.inputHelpers.setInputError($contractDate, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('signedContractOn')) {
            let $signedContractDate = this.$('.signed-contract-date');
            PJQ.helpers.inputHelpers.setInputError($signedContractDate, true);
            if (this.model.get('signedContractOn') == null || this.model.get('signedContractOn').length === 0) {
                PJQ.helpers.inputHelpers.setInputError($signedContractDate, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('letterOfIntentOn')) {
            let $letterOfIntentDate = this.$('.letter-of-intent');
            PJQ.helpers.inputHelpers.setInputError($letterOfIntentDate, true);
            if (this.model.get('letterOfIntentOn') == null || this.model.get('letterOfIntentOn').length === 0) {
                PJQ.helpers.inputHelpers.setInputError($letterOfIntentDate, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('approvalLetterOn')) {
            let $approvalLetterDate = this.$('.approval-letter');
            PJQ.helpers.inputHelpers.setInputError($approvalLetterDate, true);
            if (this.model.get('approvalLetterOn') == null || this.model.get('approvalLetterOn').length === 0) {
                PJQ.helpers.inputHelpers.setInputError($approvalLetterDate, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('issuedOn')) {
            let $issuedOnDate = this.$('.contract-issued-on');
            PJQ.helpers.inputHelpers.setInputError($issuedOnDate, true);
            if (this.model.get('issuedOn') == null || this.model.get('issuedOn').length === 0) {
                PJQ.helpers.inputHelpers.setInputError($issuedOnDate, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('executedOn')) {
            let $executedOnDate = this.$('.execution-date');
            PJQ.helpers.inputHelpers.setInputError($executedOnDate, true);
            if (this.model.get('executedOn') == null || this.model.get('executedOn').length === 0) {
                PJQ.helpers.inputHelpers.setInputError($executedOnDate, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('returnedOn')) {
            let $returnedOnDate = this.$('.contract-returned');
            PJQ.helpers.inputHelpers.setInputError($returnedOnDate, true);
            if (this.model.get('returnedOn') == null || this.model.get('returnedOn').length === 0) {
                PJQ.helpers.inputHelpers.setInputError($returnedOnDate, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('contractTerminatedOn')) {
            let $contractTerminatedOnDate = this.$('.contract-termination');
            PJQ.helpers.inputHelpers.setInputError($contractTerminatedOnDate, true);
            if (this.model.get('contractTerminatedOn') == null || this.model.get('contractTerminatedOn').length === 0) {
                PJQ.helpers.inputHelpers.setInputError($contractTerminatedOnDate, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('inclusions')) {
            let $inclusions = this.$('.inclusions');
            PJQ.helpers.inputHelpers.setInputError($inclusions, true);
            if (_.size(this.model.get('inclusions')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($inclusions, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('exclusions')) {
            let $exclusions = this.$('.exclusions');
            PJQ.helpers.inputHelpers.setInputError($exclusions, true);
            if (_.size(this.model.get('exclusions')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($exclusions, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('attachments')) {
            this.fileUploader.clearError();
            let hasValidAttachment = _.find(this.model.attachments.models, function (model) {
                return !model.get('delete')
            }, this) != null;

            if (!hasValidAttachment) {
                this.fileUploader.showError('Missing attachment', 100000);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('signedDocumentAttachments')) {
            this.signedDocumentUploader.clearError();
            let hasValidAttachment = _.find(this.model.signedDocumentAttachments.models, function (model) {
                return !model.get('delete')
            }, this) != null;

            if (!hasValidAttachment) {
                this.signedDocumentUploader.showError('Missing attachment', 100000);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('executedDocumentAttachments')) {
            this.executedDocumentUploader.clearError();
            let hasValidAttachment = _.find(this.model.executedDocumentAttachments.models, function (model) {
                return !model.get('delete')
            }, this) != null;

            if (!hasValidAttachment) {
                this.executedDocumentUploader.showError('Missing attachment', 100000);
                isValid = false;
            }
        }

        if (!isValid) {
            this.activateView(this.views.GENERAL);
            return isValid;
        }

        if (!this.lineItemsView.validate()) {
            isValid = false;
            this.activateView(this.views.LINEITEMS);
            return isValid;
        }

        return isValid;
    },
    saveEmail: function () {
        this.save((success) => {
            if (success) {
                PJQ.notifications.notify.successNotify({
                    message: 'Contract saved successfully'
                });

                this.email();
            }
        });
    },
    savePrimeContract: function () {
        this.save((success) => {
            if (success) {
                PJQ.notifications.notify.successNotify({
                    message: 'Contract saved successfully'
                });
                this.removeModal()
            }
        });
    },
    save: function (callback) {
        if (!this.validate()) {
            this.$('.modal').prevObject.scrollTop(0);
            if (typeof callback === 'function') {
                callback(false);
            }
            return;
        }

        this.model.save(null, {
            success: () => {
                this.render();
                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }

                PJQ.app.session.project.trigger('contractChanged', this.model);
                if (typeof callback === 'function') {
                    callback(true);
                }
            },
            error: () => {
                if (typeof callback === 'function') {
                    callback(false);
                }
                PJQ.notifications.notify.errorNotify({
                    message: "Encountered an error while saving this Contract. Please contact customer service."
                });
            }
        })
    },
    email: function () {
        let projectName = this.options.project?.get('projectName')?.trim();
        let subject = `A Contract has been shared with you ${projectName && _.size(projectName) > 0 ? `for ${projectName}` : ''}`;
        new PJQ.views.email.ComposeEmailModal({
            header: "Email Contract",
            project: PJQ.app.session.project,
            subject: subject,
            onSave: _.bind(function (data) {
                this.model.share(data, _.bind(function () {
                    PJQ.notifications.notify.successNotify({
                        message: 'Contract email sent'
                    });
                }, this));
            }, this)
        });
    },
    close: function () {
        if (this.model.hasChanged() && this.options.canEdit) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.savePrimeContract();
                    this.removeModal();
                }, this),
                onDontSave: _.bind(function () {
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    }
});
PJQ.views.primeContracts.PrimeContractsList = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PRIMECONTRACTS, 'prime-contracts-list'),
        primeContractId: null
    },
    events: {
        'click .btn-pull-erp': 'pullERP',
        'click .btn-settings': 'editSettings',
        'click .btn-add-prime-contract': 'addPrimeContractClicked',
        'click .btn-delete-prime-contract': 'deletePrimeContractClicked',
        'click .btn-view-prime-contract': 'viewPrimeContractClicked',
        'click .btn-add-change-order': 'addChangeOrderClicked',
        'click .btn-export': 'exportPrimeContractList'
    },
    beforeFirstRender: async function () {
        this.isFetched = false;

        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;

        if (this.collection == null) {
            this.collection = new PJQ.collections.primeContracts.PrimeContracts(null, {
                projectId: PJQ.app.session.project.id,
                costCodeId: this.options.costCodeId ? this.options.costCodeId : null,
                costTypeId: this.options.costTypeId ? this.options.costTypeId : null
            });
        }

        if (!this.collection.isFetched) {
            await this.collection.fetch();
        }

        this.userSettings = await PJQ.app.session.fetchPrimeContractUserSettings();
        this.customFields = await this.options.project.fetchPrimeContractCustomFields();
        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();

        if (this.erpIntegration != null && this.erpIntegration.getSetting('syncProjects')) {
            await this.options.project.fetchERPObject();
        }

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.options.canEdit = this.options.project.hasPermission('primeContracts.canEdit');
        this.options.isAdmin = this.options.project.hasPermission('primeContracts.isAdmin');
    },
    renderData: function () {
        return {
            collection: this.collection,
            isFetched: this.isFetched
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.renderView();

        if (this.options.primeContractId > 0) {
            let initContract = this.collection.get(this.options.primeContractId);
            if (initContract != null) {
                this.viewPrimeContract(initContract);
                this.options.primeContractId = null;
            }
        }
    },
    renderERPButton: function () {
        let $erp = this.$('.erp-sync');
        if (!this.options.isAdmin || this.erpIntegration == null || !this.erpIntegration.getSetting(PJQ.constants.integrations.settings.SYNC_PRIME_CONTRACTS) || !this.options.project || !this.options.project.isERPSynced()) {
            $erp.remove();
            return;
        }

        let pullSupported = this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PULL_PRIME_CONTRACTS);
        this.erpButtons = PJQ.helpers.erp.renderERPButtons($erp, {
            pushSupported: false,
            pullSupported: pullSupported
        });
    },
    pullERP: function () {
        if (this.options.project != null && this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PULL_PRIME_CONTRACTS)) {
            this.erpButtons?.pulling(true);
            this.erpIntegration.pullPrimeContracts(this.options.project, _.bind(function (res) {
                this.erpButtons?.pulling(false);
                this.collection.reset(res);
                PJQ.notifications.notify.successNotify({
                    message: 'Contracts pulled from ERP'
                });
                this.render();
            }, this));
        }
    },
    renderView: function () {
        if (this.dataTable) {
            this.dataTable.remove();
            this.dataTable = null;
        }

        this.dataTable = this.getDataTableInstance();
    },
    getDataTableInstance: function () {
        return new PJQ.views.primeContracts.PrimeContractDataTable({
            el: this.$('.prime-contracts-data'),
            rowId: "cid",
            data: this.collection.models,
            onPageSizeChange: function (value) {
                // PJQ.helpers.cookieHelpers.setCookie(PJQ.constants.cookies.RFI_PAGE_LENGTH, value);
            },
            isAdmin: this.options.isAdmin,
            statusIds: this.options.statusIds,
            headerData: _.bind(function () {
                return {
                    project: this.options.project,
                    canAdd: this.options.canEdit,
                    isAdmin: this.options.isAdmin
                };
            }, this),
            userSettings: this.userSettings,
            settings: this.userSettings.getSettings(PJQ.constants.primeContracts.view.PRIME_CONTRACTS),
            order: [[1, 'asc']],
            colReorder: {
                fixedColumnsLeft: 1,
                fixedColumnsRight: 1,
                realtime: false
            },
            columnOrderChanged: _.bind(function () {
                this.userSettings.save();
            }, this),
            onRowDoubleClick: _.bind(function (row) {
                this.viewPrimeContract(row.data());
            }, this),
            afterDataTableRender: _.bind(function () {
                this.renderERPButton();
            }, this),
            contextMenuOptions: {
                actions: [
                    {
                        name: 'View',
                        onClick: _.bind(function (row) {
                            this.viewPrimeContract(row.data());
                        }, this)
                    },
                    {
                        name: 'New Change Order',
                        onClick: _.bind(function (row) {
                            this.addChangeOrder(row.data());
                        }, this),
                        isShown: _.bind(function (row) {
                            let status = row.data().get('statusId');
                            return status === (PJQ.constants.primeContracts.primeContractStatus.APPROVED || PJQ.constants.primeContracts.primeContractStatus.COMPLETE) && this.options.project.hasPermission('primeContractChangeOrders.canAdd');
                        }, this),
                    },
                    {
                        name: 'New Change Request',
                        onClick: _.bind(function (row) {
                            this.addChangeRequest(row.data());
                        }, this),
                        isShown: _.bind(function (row) {
                            let status = row.data().get('statusId');
                            return status === (PJQ.constants.primeContracts.primeContractStatus.APPROVED || PJQ.constants.primeContracts.primeContractStatus.COMPLETE) && this.options.project.hasPermission('changeRequests.canAdd');
                        }, this),
                    },
                ]
            }
        });
    },
    addPrimeContractClicked: function () {
        this.viewPrimeContract();
    },
    exportPrimeContractList: function () {
        let parameters = [
            {
                parameter: 'timeZoneOffset',
                value: new Date().getTimezoneOffset()
            }
        ];

        PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: PJQ.app.session.project.id
            },
            {
                endpoint: 'primecontracts'
            },
            {
                endpoint: 'export'
            }
        ], parameters), {isAPIv2: true});
    },
    editSettings: function () {
        new PJQ.views.primeContracts.PrimeContractSettingsModal({
            primeContractView: this,
            onSave: _.bind(function () {
                this.render();
            }, this)
        });
    },
    addChangeOrderClicked: function (e) {
        let row = this.dataTable.getRow((e.currentTarget).closest('tr'));
        this.addChangeOrder(row.data());
    },
    addChangeOrder: function (primeContract) {
        new PJQ.views.primeContracts.ChangeOrderEditModal({
            primeContract: primeContract,
            onSave: _.bind(function (changeOrder) {
                primeContract.changeOrders.add(changeOrder);

                if (typeof this.options.onChangeOrderAdd === 'function') {
                    this.options.onChangeOrderAdd(changeOrder);
                }
            }, this)
        });
    },
    addChangeRequest: function (primeContract) {
        new PJQ.views.changeRequests.ChangeRequestEditModal({
            primeContract: primeContract,
            onSave: _.bind(function (changeRequest) {
                primeContract.changeRequests.add(changeRequest);

                if (typeof this.options.onChangeRequestAdd === 'function') {
                    this.options.onChangeRequestAdd(changeRequest);
                }
            }, this)
        });
    },
    viewPrimeContractClicked: function (e) {
        let row = this.dataTable.getRow((e.currentTarget).closest('tr'));
        this.viewPrimeContract(row.data());
    },
    viewPrimeContract: function (contract) {
        let isNew = contract == null;
        new PJQ.views.primeContracts.PrimeContractEditModal({
            model: contract,
            onChangeOrderAdd: _.bind(function (changeOrder) {
                if (typeof this.options.onChangeOrderAdd === 'function') {
                    this.options.onChangeOrderAdd(changeOrder);
                }
            }, this),
            onChangeOrderDelete: _.bind(function (changeOrderId) {
                if (typeof this.options.onChangeOrderDelete === 'function') {
                    this.options.onChangeOrderDelete(changeOrderId);
                }
            }, this),
            onSave: _.bind(function (model) {
                if (isNew) {
                    this.collection.add(model);
                    this.dataTable.addRow(model);
                } else {
                    this.dataTable.refresh();
                }
                if (typeof this.options.onChange === 'function') {
                    this.options.onChange();
                }
            }, this)
        })
    },
    deletePrimeContractClicked: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr'));
        this.deletePrimeContract(row);
    },
    deletePrimeContract: function (row) {
        if (row != null) {
            let primeContract = row.data();
            if (primeContract != null) {
                new PJQ.views.modals.DeleteCancel({
                    header: "Delete Contract",
                    body: "Are you sure you want to delete this Contract?",
                    onDelete: _.bind(function () {
                        primeContract.destroy({
                            success: _.bind(function () {
                                this.dataTable.removeRow(row);
                                if (typeof this.options.onDelete === 'function') {
                                    this.options.onDelete(primeContract);
                                }
                            }, this)
                        });
                    }, this)
                });
            }
        }
    }
});

PJQ.views.primeContracts.ModalViewPrimeContracts = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PRIMECONTRACTS, 'modal-view-prime-contracts'),
        maxWidth: 1000,
        isShowCloseButton: true,
        onSave: _.noop,
        isAdmin: true
    },
    events: {},
    beforeModalCreated: function () {

    },
    renderData: function () {
        return {
            model: this.model
        }
    },
    afterRender: function () {
        if (this.model != null) {
            new PJQ.views.primeContracts.PrimeContractsList({
                el: this.$('.modal-body'),
                model: this.model,
                costCodeId: this.model.get('costCodeId'),
                costTypeId: this.model.get('costTypeId'),
                statusIds: this.options.statusIds,
                project: this.options.project
            })
        }
    },
});

PJQ.views.primeContracts.SelectPrimeContractsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PRIMECONTRACTS, 'modal-select-prime-contracts'),
        width: '50%',
        maxWidth: 700,
        onSave: _.noop,
        headerSubText: null
    },
    events: {
        "change .select-prime-contract": "selectPrimeContract",
        "click .btn-save": "save",
        "click .btn-cancel": "cancel"
    },
    beforeModalCreated: function () {
        this.options.isAdmin = PJQ.app.session.project.hasPermission('primeContracts.isAdmin');

        if (this.collection == null) {
            this.collection = new PJQ.collections.primeContracts.PrimeContracts(null, {
                projectId: this.options.project.get('projectId')
            });
        }

        if (this.collection.isFetched) {
            this.render();
        } else {
            this.collection.fetch({
                success: _.bind(function () {
                    this.primeContracts = this.collection.models;

                    if (this.options.filterStatuses) {
                        this.primeContracts = _.filter(this.primeContracts, function (model) {
                            let statusId = model.get('statusId');

                            if (_.isArray(this.options.filterStatuses)) {
                                return _.includes(this.options.filterStatuses, statusId);
                            } else if (_.isNumber(this.options.filterStatuses)) {
                                return this.options.filterStatuses === statusId;
                            }

                            return false;

                        }, this);
                    }
                    this.render();
                }, this)
            });
        }

    },
    renderData: function () {
        return {
            headerSubText: this.options.headerSubText,
            isSingleChoice: this.options.isSingleChoice
        }
    },
    afterRender: function () {
        if (_.size(this.collection.models) === 1) {
            let selPc = this.collection.models[0];
            selPc.set('isSelected', true);
            this.selectedPrimeContract = selPc;
        }

        this.$('.btn-save').attr('disabled', this.selectedPrimeContract == null);

        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.prime-contracts-table'),
            data: this.primeContracts,
            isHideSearch: true,
            order: [],
            columns: [{
                "data": "attributes.isSelected",
                "title": "",
                "orderable": false,
                "searchable": false,
                "render": _.bind(function (data) {
                    return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox" ' + (data ? 'checked' : '') + ' class="select-prime-contract"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                }, this)
            },
                {
                    "data": "attributes.number",
                    "title": "Number",
                    "orderable": true
                },
                {
                    "data": "attributes.description",
                    "title": "Description",
                    "orderable": false
                },
                {
                    "data": "attributes.amount",
                    "title": "Amount",
                    "orderable": false,
                    "className": "text-align-right",
                    "render": _.bind(function (data, type, row) {
                        return PJQ.helpers.formatHelpers.formatCurrency(row.getGrandTotal());
                    }, this)
                }],
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>'
        });
    },
    selectPrimeContract: function (e) {
        let target = $(e.currentTarget),
            primeContract = this.dataTable.getRow(target.closest('tr')).data();

        if (this.options.isSingleChoice) {
            this.$('.select-prime-contract').not(target).text('Select').prop('checked', false);
            if (primeContract.get('isSelected')) {
                primeContract.set('isSelected', false);
                this.selectedPrimeContract = null;
            } else {
                primeContract.set('isSelected', true);
                this.selectedPrimeContract = primeContract;
                this.collection.get(primeContract.id);
                _.each(this.collection.models, _.bind(function (dtPrimeContract) {
                    if (primeContract.id !== dtPrimeContract.id)
                        dtPrimeContract.set('isSelected', false);
                }, this));
            }
            this.$('.btn-save').attr('disabled', this.selectedPrimeContract == null);

            if (typeof this.options.onPrimeContractSelected === 'function') {
                this.options.onPrimeContractSelected(this.selectedPrimeContract);
            }
        } else {
            if (primeContract.get('isSelected')) {
                target.text('Select').addClass('btn-primary').removeClass('btn-secondary');
                primeContract.set('isSelected', false);
                this.selectedPrimeContracts = _.reject(this.selectedPrimeContracts, function (selPrimeContract) {
                    return selPrimeContract.id === primeContract.id;
                });
            } else {
                target.text('Deselect').addClass('btn-secondary').removeClass('btn-primary');
                primeContract.set('isSelected', true);
                this.selectedPrimeContracts.push(primeContract);
            }
            this.$('.btn-save').attr('disabled', this.selectedPrimeContracts == null);

            if (typeof this.options.onPrimeContractSelected === 'function') {
                this.options.onPrimeContractSelected(this.selectedPrimeContracts);
            }
        }
    },
    cancel: function () {
        if (this.options.onCancel) {
            this.options.onCancel();
        }
        this.removeModal();
    },
    save: function () {
        if (this.options.onSave) {
            this.removeModal();
            this.options.onSave(this.selectedPrimeContract ? this.selectedPrimeContract : this.selectedPrimeContracts);
        }
    }
});
PJQ.views.primeContracts.PrimeContractManagement = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PRIMECONTRACTS, 'prime-contract-management'),
        subTemplates: {
            primeContractTotals: new PJQ.templating.Template(PJQ.constants.modules.PRIMECONTRACTS, 'prime-contract-management-totals'),
            invoiceTotals: new PJQ.templating.Template(PJQ.constants.modules.INVOICING, 'invoicing-management-totals')
        },
        primeContractId: null,
        changeOrderId: null,
        invoiceId: null,
        view: null
    },
    events: {
        'shown.bs.tab .nav-tabs': 'tabActivated',
        'click .btn-settings': 'settings'
    },
    beforeFirstRender: function () {
        this.options.canViewPrimeContracts = PJQ.app.session.project.hasPermission('primeContracts.canView');
        this.options.canViewChangeOrders = PJQ.app.session.project.hasPermission('primeContractChangeOrders.canView');
        this.options.canViewInvoices = PJQ.app.session.project.hasPermission('receivableInvoices.canView');
        this.options.canViewChangeRequests = PJQ.app.session.project.hasPermission('changeRequests.canView');
        this.options.isAdmin = PJQ.app.session.project.hasPermission('primeContracts.isAdmin')
            && PJQ.app.session.project.hasPermission('primeContractChangeOrders.isAdmin');
    },
    renderData: function () {
        return {
            primeContracts: this.primeContracts,
            changeOrders: this.changeOrders,
            invoices: this.invoices,
            canViewPrimeContracts: this.options.canViewPrimeContracts,
            canViewChangeOrders: this.options.canViewChangeOrders,
            canViewInvoices: this.options.canViewInvoices,
            isAdmin: this.options.isAdmin,
            canViewChangeRequests: this.options.canViewChangeRequests
        }
    },
    afterRender: function () {
        this.primeContractsView = null;
        this.changeOrdersView = null;
        this.invoicesView = null;
        this.changeRequestsView = null;

        this.renderStats();
        if (this.options.view != null) {
            this.activateTab(this.options.view);
        } else if (this.options.commitmentId > 0 && this.options.canViewPrimeContracts) {
            this.activateTab('primecontracts');
        } else if (this.options.changeOrderId > 0 && this.options.canViewChangeOrders) {
            this.activateTab('changeorders');
        } else if (this.options.invoiceId > 0 && this.options.canViewInvoices) {
            this.activateTab('invoices');
        } else if (this.options.changeRequestId > 0 && this.options.canViewChangeRequests) {
            this.activateTab('changerequests');
        } else if (this.options.canViewPrimeContracts) {
            this.activateTab('primecontracts');
        } else if (this.options.canViewChangeOrders) {
            this.activateTab('changeorders');
        } else if (this.options.canViewInvoices) {
            this.activateTab('invoices');
        } else if (this.options.canViewChangeRequests) {
            this.activateTab('changerequests');
        }
    },
    renderStats: function () {
        let totals,
            $totals = this.$('.totals-outer');
        switch (this.activeView) {
            case 'changeorders':
                if (this.changeOrdersView == null || this.changeOrdersView.collection == null || !this.changeOrdersView.collection.isFetched) {
                    $totals.empty();
                    return;
                }

                totals = this.changeOrdersView.collection.getTotalAmountsByStatus();
                this.renderSubTemplate(false, this.options.subTemplates.primeContractTotals, $totals, {
                    pending: totals[PJQ.constants.primeContracts.changeOrderStatusBuckets.PENDING.name],
                    projected: totals[PJQ.constants.primeContracts.changeOrderStatusBuckets.PROJECTED.name],
                    approved: totals[PJQ.constants.primeContracts.changeOrderStatusBuckets.APPROVED.name]
                });
                break;
            case 'changerequests':
                if (this.changeRequestsView == null || this.changeRequestsView.collection == null || !this.changeRequestsView.collection.isFetched) {
                    $totals.empty();
                    return;
                }

                totals = this.changeRequestsView.collection.getTotalAmountsByStatus();
                this.renderSubTemplate(false, this.options.subTemplates.primeContractTotals, $totals, {
                    pending: totals[PJQ.constants.changeRequests.changeRequestStatusBuckets.PENDING.name],
                    projected: totals[PJQ.constants.changeRequests.changeRequestStatusBuckets.PROJECTED.name],
                    approved: totals[PJQ.constants.changeRequests.changeRequestStatusBuckets.APPROVED.name]
                });
                break;
            case 'invoices':
                if (this.invoicesView == null || this.invoicesView.collection == null || !this.invoicesView.collection.isFetched) {
                    $totals.empty();
                    return;
                }

                totals = this.invoicesView.collection.getTotalAmountsByStatus();
                this.renderSubTemplate(false, this.options.subTemplates.invoiceTotals, $totals, {
                    draft: totals[PJQ.constants.invoicing.receivableInvoiceStatus.DRAFT],
                    reviewing: totals[PJQ.constants.invoicing.receivableInvoiceStatus.REVIEWING],
                    approved: totals[PJQ.constants.invoicing.receivableInvoiceStatus.APPROVED],
                    complete: totals[PJQ.constants.invoicing.receivableInvoiceStatus.COMPLETE],
                    revise: totals[PJQ.constants.invoicing.receivableInvoiceStatus.REVISE]
                });
                break;
            default:
                if (this.primeContractsView == null || this.primeContractsView.collection == null || !this.primeContractsView.collection.isFetched) {
                    $totals.empty();
                    return;
                }

                totals = this.primeContractsView.collection.getTotalAmountsByStatus();
                this.renderSubTemplate(false, this.options.subTemplates.primeContractTotals, $totals, {
                    pending: totals[PJQ.constants.primeContracts.primeContractStatusBuckets.PENDING.name],
                    projected: totals[PJQ.constants.primeContracts.primeContractStatusBuckets.PROJECTED.name],
                    approved: totals[PJQ.constants.primeContracts.primeContractStatusBuckets.APPROVED.name]
                });
                break;
        }
    },
    activateTab: function (tab) {
        this.activeView = tab;

        switch (tab ? tab.toLowerCase() : null) {
            case 'changeorders':
                tab = 'PCCO_List';
                this.renderChangeOrdersView();
                break;
            case 'invoices':
                tab = 'RI_List';
                this.renderInvoicesView();
                break;
            case 'changerequests':
                tab = 'CR_List';
                this.renderChangeRequestsView();
                break;
            default:
                tab = 'PC_List';
                this.renderPrimeContractsView();
                break;
        }

        this.isActivating = true;
        this.$('.nav-link[href="#' + tab + '"]').tab('show');
        this.isActivating = false;

        this.renderStats();
    },
    tabActivated: function (e) {
        if (this.isActivating) {
            return;
        }

        this.activeTab = $(e.target).attr('href');

        let vw;
        switch (this.activeTab) {
            case '#PC_List':
                vw = 'contracts';
                break;
            case '#PCCO_List':
                vw = 'changeorders';
                break;
            case '#CR_List':
                vw = 'changerequests';
                break;
            case '#RI_List':
                vw = 'invoices';
                break;
        }
        this.activateTab(vw);
    },
    renderPrimeContractsView: function () {
        PJQ.app.router.navigate('projects/' + this.options.project.id.toString() + '/contracts', {
            trigger: false
        });
        if (this.primeContractsView == null && this.options.canViewPrimeContracts) {
            let fnRender = _.bind(function () {
                this.primeContractsView = new PJQ.views.primeContracts.PrimeContractsList({
                    el: this.$('.prime-contracts-pane'),
                    project: PJQ.app.session.project,
                    primeContractId: this.options.primeContractId,
                    collection: this.primeContracts,
                    afterRender: _.bind(this.renderStats, this),
                    onChange: _.bind(function () {
                        this.renderStats();
                    }, this),
                    onChangeOrderAdd: _.bind(function (changeOrder) {
                        if (this.changeOrders != null) {
                            this.changeOrders.add(changeOrder);

                            if (this.changeOrdersView != null) {
                                this.changeOrdersView.render();
                            }
                        }
                        this.renderStats();
                    }, this),
                    onInvoiceAdd: _.bind(function (invoice) {
                        if (this.invoices != null) {
                            this.invoices.add(invoice);

                            if (this.invoicesView != null) {
                                this.invoicesView.render();
                            }
                        }
                    }, this)
                });
                this.options.primeContractId = null;
            }, this)

            if (this.primeContracts == null) {
                this.primeContracts = new PJQ.collections.primeContracts.PrimeContracts(null, {
                    projectId: this.options.project.get('projectId')
                });
                this.primeContracts.fetch({
                    success: _.bind(function () {
                        fnRender();
                    }, this)
                });
            } else {
                fnRender();
            }
        }
    },
    renderChangeOrdersView: function () {
        PJQ.app.router.navigate('projects/' + this.options.project.id.toString() + '/contracts/changeorders', {
            trigger: false
        });
        if (this.changeOrdersView == null && this.options.canViewChangeOrders) {
            let fnRender = _.bind(function () {
                this.changeOrdersView = new PJQ.views.primeContracts.ChangeOrdersList({
                    el: this.$('.change-orders-pane'),
                    project: PJQ.app.session.project,
                    changeOrderId: this.options.changeOrderId,
                    collection: this.changeOrders,
                    afterRender: _.bind(this.renderStats, this),
                });
                this.options.changeOrderId = null;
            }, this);

            if (this.changeOrders == null) {
                this.changeOrders = new PJQ.collections.primeContracts.ChangeOrders(null, {
                    projectId: this.options.project.get('projectId')
                });
                this.changeOrders.fetch({
                    success: _.bind(function () {
                        fnRender();
                    }, this)
                });
            } else {
                fnRender();
            }
        }
    },
    renderChangeRequestsView: function () {
        PJQ.app.router.navigate('projects/' + this.options.project.id.toString() + '/contracts/changerequests', {
            trigger: false
        });

        if (this.changeRequestsView == null && this.options.canViewChangeRequests) {
            let fnRender = () => {
                this.changeRequestsView = new PJQ.views.changeRequests.ChangeRequestsList({
                    el: this.$('.change-requests-pane'),
                    project: PJQ.app.session.project,
                    changeRequestId: this.options.changeRequestId,
                    collection: this.changeRequests,
                    hideHeader: true,
                    afterRender: () => this.renderStats(),
                });
                this.options.changeRequestId = null;
            };

            if (this.changeRequests == null) {
                this.changeRequests = new PJQ.collections.changeRequests.ChangeRequests(null, {
                    projectId: this.options.project.get('projectId')
                });
                this.changeRequests.fetch({
                    success: _.bind(function () {
                        fnRender();
                    }, this)
                });
            } else {
                fnRender();
            }
        }
    },
    renderInvoicesView: function () {
        PJQ.app.router.navigate('projects/' + this.options.project.id.toString() + '/contracts/invoices', {
            trigger: false
        });
        if (this.invoicesView == null && this.options.canViewInvoices) {
            let fnRender = () => {
                this.invoicesView = new PJQ.views.invoicing.ReceivableInvoicesList({
                    el: this.$('.invoices-pane'),
                    project: PJQ.app.session.project,
                    invoiceId: this.options.invoiceId,
                    collection: this.invoices,
                    afterRender: _.bind(this.renderStats, this),
                    onDelete: _.bind(function (invoice) {
                        this.invoices.remove(invoice);
                    }, this)
                });
                this.options.invoiceId = null;
            }

            if (this.invoices == null) {
                this.invoices = new PJQ.collections.invoicing.ReceivableInvoices(null, {
                    project: this.options.project
                });
                this.invoices.fetch({
                    success: _.bind(function () {
                        fnRender();
                    }, this)
                })
            } else {
                fnRender();
            }
        }
    },
    getActiveTab: function () {
        return this.$('.nav-item>.nav-link.active').attr('href');
    },
    settings: function () {
        switch (this.getActiveTab()) {
            case '#PC_List':
                if (this.primeContractsView != null) {
                    this.primeContractsView.editSettings();
                }
                break;
            case '#PCCO_List':
                if (this.changeOrdersView != null) {
                    this.changeOrdersView.editSettings();
                }
                break;
            case '#CR_List':
                if (this.changeRequestsView != null) {
                    this.changeRequestsView.editSettings();
                }
                break;
            case '#RI_List':
                if (this.invoicesView != null) {
                    this.invoicesView.editSettings();
                }
                break;
        }
    },
    updateTotalsCount: function () {
        let $primeContractSpan = this.$('.prime-contracts-total'),
            $changeOrdersSpan = this.$('.change-orders-total'),
            $changeRequestsSpan = this.$('.change-requests-total'),
            $invoiceSpan = this.$('.invoices-total');
        $primeContractSpan.text(_.size(this.primeContracts.models));
        $changeOrdersSpan.text(_.size(this.changeOrders.models));
        $changeRequestsSpan.text(_.size(this.changeRequests.models));
        $invoiceSpan.text(_.size(this.invoices.models));
    }
});
//Models
PJQ.models.primeContracts.PrimeContract = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        if (this.isNew()) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.get('projectId')
                },
                {
                    endpoint: 'primecontracts',
                    value: this.id
                }
            ]);
        } else {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'primecontracts',
                    value: this.id
                }
            ]);
        }
    },
    parse: function (model) {
        if (!model)
            return model;

        this.attachments = new PJQ.collections.primeContracts.Attachments(model.attachments);
        this.signedDocumentAttachments = new PJQ.collections.primeContracts.Attachments(model.signedDocumentAttachments);
        this.executedDocumentAttachments = new PJQ.collections.primeContracts.Attachments(model.executedDocumentAttachments);
        this.customFieldAttachments = new PJQ.collections.primeContracts.Attachments(model.customFieldAttachments);
        this.lineItems = new PJQ.collections.primeContracts.LineItems(model.lineItems);
        this.changeOrders = new PJQ.collections.primeContracts.ChangeOrders(model.changeOrders);
        this.changeRequests = new PJQ.collections.changeRequests.ChangeRequests(model.changeRequests);
        this.invoices = new PJQ.collections.invoicing.ReceivableInvoices(model.invoices);
        this.payments = new PJQ.collections.invoicing.ReceivableInvoicePayments(model.payments);

        this.markupItems = new PJQ.financialMarkups.collections.FinancialMarkups(model ? model.markupItems : null);

        if (model.client) {
            if (model.client instanceof PJQ.models.BaseModel) {
                this.client = model.client;
            } else {
                this.client = new PJQ.models.contacts.Contact(model.client);
            }
        }

        if (model.architect) {
            if (model.architect instanceof PJQ.models.BaseModel) {
                this.architect = model.architect;
            } else {
                this.architect = new PJQ.models.contacts.Contact(model.architect);
            }
        }

        return model;
    },
    beforeSave: function () {
        let newMarkupLines = this.lineItems.filter(function (lineItem) {
            return lineItem.markup && lineItem.isNew();
        });
        this.lineItems.remove(newMarkupLines);

        this.set({
            lineItems: this.lineItems.toJSON(),
            attachments: this.attachments.toJSON(),
            signedDocumentAttachments: this.signedDocumentAttachments.toJSON(),
            executedDocumentAttachments: this.executedDocumentAttachments.toJSON(),
            customFieldAttachments: this.customFieldAttachments.toJSON(),
            markupItems: this.markupItems.toJSON()
        });
    },
    syncERP: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/syncerp',
            isAPIv2: true,
        }).post().done(_.bind(function (res) {
            if (res && _.size(res.externalId) > 0) {
                this.set('externalObject', res);
            }
            if (typeof callback === 'function') {
                callback(res);
            }
        }, this)).fail(_.bind(function (xhr, err, result) {
            if (typeof callback === 'function') {
                callback(null);
            }
        }, this));
    },
    unlinkERP: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/unlinkerp',
            isAPIv2: true,
        }).post().done(_.bind(function () {
            this.set('externalObject', null);
            if (typeof callback === 'function') {
                callback(true);
            }
        }, this)).fail(_.bind(function (xhr) {
            if (typeof callback === 'function') {
                let err;
                if (xhr.responseJSON != null) {
                    err = xhr.responseJSON.type;
                } else {
                    err = null;
                }
                callback(false, err);
            }
        }, this));
    },
    makeERPUrl: function (integration) {
        let externalId = this.externalId();
        if (_.size(externalId) === 0) {
            return '';
        }

        switch (integration.get('name')) {
            case PJQ.constants.integrations.providers.QBO.name:
                return 'https://app.sandbox.qbo.intuit.com/app/estimate?txnId=' + externalId;
            default:
                return '';
        }
    },
    share: function (data, callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/email',
            isAPIv2: true,
            data: {
                subject: data != null ? data.subject : null,
                body: data != null ? data.body : null,
                toEmails: data != null ? data.toEmails : null,
                ccEmails: data != null ? data.ccEmails : null,
            }
        }).post().done(_.bind(function (response) {
            callback();
        }, this)).fail(_.bind(function (xhr, err, result) {
            //todo: error
        }, this));
    },
    getSubTotal: function () {
        return this.get('amount') + this.get('markupAmount');
    },
    getGrandTotal: function () {
        return this.getSubTotal() + this.get('taxAmount');
    }
});

PJQ.models.primeContracts.HistoryItem = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    actionNames: {
        'status': 'Status Changed',
        'submit': 'Submitted',
        'signed': 'Signed',
        'email': 'Email Sent'
    },
    getActionName: function () {
        return this.actionNames[this.get('action')] ?? this.get('action');
    },
    getDescription: function () {
        switch (this.get('action')) {
            case 'status':
                let fromStatus = this.get('data').from,
                    toStatus = this.get('data').to;
                if (fromStatus == null || toStatus == null) {
                    return '';
                }

                return '' + PJQ.constants.primeContracts.primeContractStatusNames[fromStatus] + '<i class="fal fa-arrow-right ml-1 mr-1 fs-14"></i>' + PJQ.constants.primeContracts.primeContractStatusNames[toStatus];
            case 'email':
                let to = this.get('data').to;
                if (_.size(to) === 0) {
                    return '';
                }

                return 'To: ' + to.join(', ');
            default:
                return '';
        }
    }
});

PJQ.models.primeContracts.LineItem = PJQ.models.budget.BaseLineItem.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id'
});

PJQ.models.primeContracts.Attachment = PJQ.models.files.File.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id'
});

PJQ.models.primeContracts.Settings = PJQ.models.budget.Settings.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    endpoint: function () {
        if (this.options.projectId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'primeContracts'
                },
                {
                    endpoint: 'settings'
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'primeContracts'
            },
            {
                endpoint: 'settings'
            }
        ]);
    }
});

PJQ.models.primeContracts.Term = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'termsId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'primecontracts'
            },
            {
                endpoint: 'terms',
                value: this.id
            }
        ]);
    }
});

PJQ.models.primeContracts.FieldSetting = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'fields',
                value: this.id ? this.id : 'primecontracts'
            }
        ]);
    }
});

PJQ.models.primeContracts.PrimeContractUserSettings = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'primecontracts'
            },
            {
                endpoint: 'user'
            }
        ]);
    },
    getSettings: function (view) {
        return _.find(this.attributes.viewSettings, _.bind(function (setting) {
            return setting.view === view;
        }, this));
    }
});

PJQ.models.primeContracts.CustomField = PJQ.models.customFields.CustomField.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'primecontracts'
            },
            {
                endpoint: 'customfields',
                value: this.get('id')
            }
        ]);
    }
});

PJQ.models.primeContracts.CustomFieldChoice = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'primecontracts'
            },
            {
                endpoint: 'customfields',
                value: this.get('customFieldId')
            },
            {
                endpoint: 'choices',
                value: this.get('id')
            }
        ]);
    }
});

//Collections
PJQ.collections.primeContracts.PrimeContracts = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.primeContracts.PrimeContract,
    endpoint: function () {
        let params = [];
        if (this.options.costCodeId && this.options.costTypeId) {
            params.push({
                parameter: 'costCodeId',
                value: this.options.costCodeId
            }, {
                parameter: 'costTypeId',
                value: this.options.costTypeId
            });
        }
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.projectId
            },
            {
                endpoint: 'primecontracts'
            }
        ], params);
    },
    getTotalAmountsByStatus: function () {
        let result = {};
        _.each(PJQ.constants.primeContracts.primeContractStatusBuckets, function (bucket) {
            let total = 0;
            _.each(this.models, function (contract) {
                if (bucket.statuses.indexOf(contract.get('statusId')) !== -1) {
                    total += contract.get('totalAmount');
                }
            });
            result[bucket.name] = total;
        }, this);
        return result;
    }
});

PJQ.collections.primeContracts.History = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.primeContracts.HistoryItem,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'primecontracts',
                value: this.options.primeContractId
            },
            {
                endpoint: 'history'
            }
        ]);
    }
});

PJQ.collections.primeContracts.LineItems = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.primeContracts.LineItem,
    endpoint: function () {
        let params = [];
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'primecontracts',
                value: this.options.primeContractId
            },
            {
                endpoint: 'lineitems'
            }
        ], params);
    }
});

PJQ.collections.primeContracts.Attachments = PJQ.collections.files.Files.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.primeContracts.Attachment,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'primeContracts',
                value: this.options.primeContractId
            },
            {
                endpoint: 'attachments'
            }
        ]);
    }
});

PJQ.collections.primeContracts.CustomFields = PJQ.collections.customFields.CustomFields.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.primeContracts.CustomField,
    endpoint: function () {
        if (this.options.projectId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'primecontracts'
                },
                {
                    endpoint: 'customfields'
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'primecontracts'
            },
            {
                endpoint: 'customfields'
            }
        ]);
    }
});

PJQ.collections.primeContracts.CustomFieldChoices = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.primeContracts.CustomFieldChoice
});

PJQ.collections.primeContracts.Terms = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.primeContracts.Term,
    endpoint: function () {
        if (this.options.projectId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'primecontracts'
                },
                {
                    endpoint: 'terms'
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'primecontracts'
            },
            {
                endpoint: 'terms'
            }
        ]);
    }
});

PJQ.collections.primeContracts.FieldSettings = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.primeContracts.FieldSetting,
    endpoint: function () {
        if (this.options.projectId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'settings'
                },
                {
                    endpoint: 'fields',
                    value: 'primecontracts'
                },
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'fields',
                value: 'primecontracts'
            }
        ]);
    }
});
PJQ.views.primeContracts.PrimeContractSettingsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PRIMECONTRACTS, 'modal-prime-contract-settings'),
        minWidth: '600px',
    },
    events: {
        'change .select-column': 'columnSelected',
        'click .btn-edit-company-default': 'editCompanySettings',
        'click button.settings-save': 'onSave'
    },
    beforeModalCreated: function () {
        this.userSettings = this.options.primeContractView.userSettings;
        this.customFields = this.options.primeContractView.customFields;
    },
    beforeRender: function () {
        // copy userSettings for our UI; we only update global userSettings object on save.
        this.options.userSettings = [];

        this.options.defaultPrimeContractStatusFilter = this.userSettings.get('defaultPrimeContractStatusFilter');
        _.each(this.userSettings.attributes.viewSettings, _.bind(function (setting) {
            let columns = this.options.primeContractView.dataTable.getColumns(true),
                selectedColumns = (_.size(setting.columns) > 0) ? setting.columns : setting.columnsDefault;
            _.each(columns, _.bind(function (column) {
                column.visible = selectedColumns.indexOf(column.columnData) !== -1
            }, this));

            this.options.userSettings.push({
                view: setting.view,
                rowsPerPage: setting.rowsPerPage,
                columns: columns
            });
        }, this));
    },
    renderData: function () {
        return {
            userSettings: this.userSettings
        }
    },
    afterRender: function () {
        let defaultFilter = {};
        defaultFilter[PJQ.constants.primeContracts.filterType.PRIME_CONTRACT_STATUS_FILTER] = this.userSettings.get('defaultPrimeContractStatusFilter');

        this.defaultFilterSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-filter-default'),
            isIntChoices: true,
            isMultiple: true,
            isGrouped: true,
            defaultValue: defaultFilter,
            onChange: _.bind(function () {
                this.options.defaultPrimeContractStatusFilter = this.defaultFilterSelectPicker.getValue()[PJQ.constants.primeContracts.filterType.PRIME_CONTRACT_STATUS_FILTER];
            }, this)
        });

        this.rowsPerPage = new PJQ.inputs.Selectpicker({
            el: this.$('select.rows-per-page'),
            isIntChoices: true,
            onChange: _.bind(function (value) {
                this.currentView.rowsPerPage = value;
            }, this)
        });

        this.selectView(PJQ.constants.primeContracts.view.PRIME_CONTRACTS);
    },
    editCompanySettings: function () {
        this.userSettings = new PJQ.models.primeContracts.PrimeContractUserSettings(null, {
            forCompany: true
        });
        this.userSettings.fetch({
            success: _.bind(function () {
                this.render();
            }, this)
        });
    },
    selectView: function (view) {
        this.currentView = _.find(this.options.userSettings, _.bind(function (setting) {
            return setting.view === view;
        }, this));

        this.rowsPerPage.setValue(this.currentView.rowsPerPage);

        if (this.dataTable) {
            this.dataTable.undelegateEvents();
            $(this.dataTable.el).empty();
        }

        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('div.select-columns-datatable'),
            data: this.currentView.columns,
            isHideSearch: true,
            pageLength: 6,
            order: [],
            columns: [
                {"data": "title", "title": "Column", "orderable": false},
                {
                    "data": "visible",
                    "title": "Show",
                    "orderable": false,
                    "searchable": false,
                    "render": _.bind(function (data) {
                        return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox"' + (data ? ' checked ' : '') + 'class="select-column"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                    }, this),
                    "width": '10%'
                }
            ],
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>'
        });

    },
    columnSelected: function (sender) {
        this.dataTable.dataTable.row($(sender.currentTarget).closest('tr')).data().visible = $(sender.currentTarget).prop('checked');
    },
    onSave: function () {
        let fnOnSave = _.bind(function () {
            if (typeof this.options.onSave === 'function')
                this.options.onSave();
            this.removeModal();
        }, this);

        this.userSettings.set('defaultPrimeContractStatusFilter', this.options.defaultPrimeContractStatusFilter);

        _.each(this.options.userSettings, _.bind(function (settingTemp) {
            _.each(this.userSettings.get('viewSettings'), _.bind(function (setting) {
                if (settingTemp.view === setting.view) {
                    setting.rowsPerPage = settingTemp.rowsPerPage;

                    let columns = _.size(setting.columns) > 0 ? setting.columns.slice() : setting.columnsDefault.slice();

                    // update columns
                    _.each(settingTemp.columns, _.bind(function (column) {
                        if (column.visible) {
                            if (columns.indexOf(column.columnData) === -1)
                                columns.push(column.columnData);
                        }
                        else {
                            if (columns.indexOf(column.columnData) !== -1)
                                columns = _.filter(columns, _.bind(function (columnTemp) {
                                    return columnTemp != column.columnData;
                                }, this));
                        }
                    }, this));

                    setting.columns = columns;
                }
            }, this));
        }, this));

        this.userSettings.save(null, {
            success: _.bind(function () {
                fnOnSave();
            }, this)
        });
    },
});